/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
};

export type AddLessonTo1on1PlanSlotInput = {
  endUtc?: InputMaybe<Scalars["String"]["input"]>;
  startUtc: Scalars["String"]["input"];
};

export type AdditionalSlot = {
  endDateUtc: Scalars["String"]["output"];
  startDateUtc: Scalars["String"]["output"];
};

export type AdditionalSlotInput = {
  endDateUtc?: Scalars["String"]["input"];
  startDateUtc?: Scalars["String"]["input"];
};

export type AgGridParamsInput = {
  endRow: Scalars["Int"]["input"];
  filterModel: Scalars["JSON"]["input"];
  groupKeys: Array<Scalars["String"]["input"]>;
  queryId: Scalars["String"]["input"];
  rowGroupCols: Scalars["JSON"]["input"];
  sortModel: Scalars["JSON"]["input"];
  startRow: Scalars["Int"]["input"];
  valueCols: Scalars["JSON"]["input"];
};

export type AgGridQueryResponse = {
  data: Scalars["JSON"]["output"];
  hasNext: Scalars["Boolean"]["output"];
};

export type AllYouCanSpeakBonusStatus = {
  freeBookingsUnlocked: Scalars["Boolean"]["output"];
  isBonusActive: Scalars["Boolean"]["output"];
  lessonsCountedPerWeek?: Maybe<Scalars["Float"]["output"]>;
};

export type ApplyWithdrawalOutcomeGraphqlInput = {
  dealId?: InputMaybe<Scalars["String"]["input"]>;
  outcome: WithdrawalOutcome;
  outcomeRawValue: Scalars["String"]["input"];
  requestId?: InputMaybe<Scalars["String"]["input"]>;
};

export type AvailabilitySlotDto = {
  endDateUtc: Scalars["String"]["output"];
  slotId: Scalars["String"]["output"];
  slotTimezone: Scalars["String"]["output"];
  startDateUtc: Scalars["String"]["output"];
};

export type AvailableTeacherSlot = {
  endUtc: Scalars["String"]["output"];
  slotTimezone: Scalars["String"]["output"];
  startUtc: Scalars["String"]["output"];
  teacherIds: Array<Scalars["String"]["output"]>;
};

export type AvailableWeekDayForGroup = {
  availableWeekDays: Array<WeekDayEnum>;
};

export type BookSlotClassRoomInput = {
  id: Scalars["String"]["input"];
};

export type BookSlotInput = {
  classRoom?: InputMaybe<BookSlotClassRoomInput>;
  endDateUtc: Scalars["String"]["input"];
  slotId: Scalars["String"]["input"];
  startDateUtc: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
};

export type BookableSlot = {
  capacity: Scalars["Int"]["output"];
  classRoom?: Maybe<BookableSlotClassRoom>;
  endDateUtc: Scalars["String"]["output"];
  hasEnoughRemainingLessons: Scalars["Boolean"]["output"];
  participantsCount: Scalars["Int"]["output"];
  slotId: Scalars["ID"]["output"];
  slotLevel: SpeakingClassLevel;
  slotTimezone: Scalars["String"]["output"];
  slotType: ClassRoomType;
  startDateUtc: Scalars["String"]["output"];
  topic: Topic;
  userIsAParticipant: Scalars["Boolean"]["output"];
};

export type BookableSlotClassRoom = {
  canBeLeaved: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
};

export type BookedClassRoom = {
  classRoomId: Scalars["String"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endUtc: Scalars["String"]["output"];
  is1on1?: Maybe<Scalars["Boolean"]["output"]>;
  startUtc: Scalars["String"]["output"];
  teacherId: Scalars["String"]["output"];
  userGroupId: Scalars["String"]["output"];
};

export type BulkClassRoomCreationIntent = {
  additionalSlots?: Maybe<Array<AdditionalSlot>>;
  createdAt: Scalars["DateTimeISO"]["output"];
  excludedSlots?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["String"]["output"];
  maxClassRoomNumber?: Maybe<Scalars["Int"]["output"]>;
  numberOfWeeks?: Maybe<Scalars["Int"]["output"]>;
  startDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  teacher?: Maybe<BulkClassRoomCreationIntentTeacherGraphqlDto>;
  user?: Maybe<BulkClassRoomCreationIntentUserGraphqlDto>;
  user1on1ClassroomPlanToBeRedeemedId?: Maybe<Scalars["String"]["output"]>;
  weekSlots?: Maybe<Array<WeekSlot>>;
};

export type BulkClassRoomCreationIntentTeacherGraphqlDto = {
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type BulkClassRoomCreationIntentUserGraphqlDto = {
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type BulkClassRoomCreationRequestGraphqlDto = {
  createdAt: Scalars["DateTimeISO"]["output"];
  id: Scalars["String"]["output"];
  status: BulkClassRoomCreationRequestStatus;
  teacher: BulkClassRoomCreationRequestTeacherGraphqlDto;
  totalClassRoomsToCreate: Scalars["Float"]["output"];
  updatedAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  user: BulkClassRoomCreationRequestUserGraphqlDto;
};

export enum BulkClassRoomCreationRequestStatus {
  Completed = "Completed",
  Creating = "Creating",
}

export type BulkClassRoomCreationRequestTeacherGraphqlDto = {
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type BulkClassRoomCreationRequestUserGraphqlDto = {
  authId: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export enum BusinessEnglishObjective {
  Negoziazioni = "Negoziazioni",
  Networking = "Networking",
  Presentazioni = "Presentazioni",
}

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type CalculateBulkClassRoomCreationSlotsInput = {
  additionalSlots?: InputMaybe<Array<AdditionalSlotInput>>;
  excludedSlots?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks: Scalars["Int"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots: Array<WeekSlotInput>;
};

export type CalculatedSlot = {
  endDateUtc: Scalars["DateTimeISO"]["output"];
  startDateUtc: Scalars["DateTimeISO"]["output"];
  teacherConflictingClass?: Maybe<ClassRoom>;
  userConflictingClass?: Maybe<ClassRoom>;
};

export type CandidateTeacherStats = {
  reviewAvg?: Maybe<Scalars["Float"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  teacherId: Scalars["String"]["output"];
  wasSelected: Scalars["Boolean"]["output"];
  weeklyCap?: Maybe<TeacherWeeklyAssignmentCap>;
};

export type ClassRoom = {
  capacity: Scalars["Int"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1: Scalars["Boolean"]["output"];
  meetingUrl: Scalars["String"]["output"];
  participants: Array<ClassRoomParticipant>;
  speakingLevel?: Maybe<SpeakingClassLevel>;
  startedAtUtc: Scalars["String"]["output"];
  topic?: Maybe<Topic>;
  type: ClassRoomType;
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export type ClassRoomListItem = {
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  completedFeedbacksCount: Scalars["Int"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
  participantsCount: Scalars["Float"]["output"];
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  teacher: ClassRoomTeacher;
  topic: Topic;
  type: ClassRoomType;
};

export type ClassRoomParticipant = {
  executedClassRoomCount: Scalars["Int"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  speakingLevel: SpeakingClassLevel;
};

export type ClassRoomReviewDto = {
  classRoom: ClassRoomWithoutParticipantDto;
  classRoomId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  reviewNotes: Scalars["String"]["output"];
  reviewedAtUtc: Scalars["String"]["output"];
  teacherId: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type ClassRoomSelectionDetail = {
  candidates: Array<CandidateTeacherStats>;
  classRoomId: Scalars["String"]["output"];
  strategyName?: Maybe<Scalars["String"]["output"]>;
};

export type ClassRoomSelectionHistoryEntry = {
  assignedAt: Scalars["String"]["output"];
  candidates: Array<CandidateTeacherStats>;
  selectedTeacherId: Scalars["String"]["output"];
  strategyName: Scalars["String"]["output"];
};

export type ClassRoomTeacher = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  phone?: Maybe<PhoneNumber>;
};

/** The class room type such as speaking class or exam */
export enum ClassRoomType {
  Exam = "Exam",
  OnboardingLive = "OnboardingLive",
  SpeakingClass = "SpeakingClass",
}

export type ClassRoomV2 = {
  canBeLeaved: Scalars["Boolean"]["output"];
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUri: Scalars["String"]["output"];
  feedbackUri: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1?: Maybe<Scalars["Boolean"]["output"]>;
  meetingUri: Scalars["String"]["output"];
  onboardingLivePdfUrl?: Maybe<Scalars["String"]["output"]>;
  participants: Array<ClassRoomParticipant>;
  participantsCount: Scalars["Float"]["output"];
  progressCheckTopic?: Maybe<ProgressCheckTopic>;
  speakingLevel?: Maybe<SpeakingClassLevel>;
  startedAtUtc: Scalars["String"]["output"];
  teacher: Franchisee;
  teacherId: Scalars["String"]["output"];
  topic?: Maybe<Topic>;
  type: ClassRoomType;
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export type ClassRoomWithMissingFeedback = {
  classRoom: ClassRoomV2;
  participantsWithoutFeedback: Array<ClassRoomParticipant>;
};

export type ClassRoomWithoutParticipantDto = {
  canBeLeaved: Scalars["Boolean"]["output"];
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1?: Maybe<Scalars["Boolean"]["output"]>;
  meetingUri: Scalars["String"]["output"];
  participantsCount: Scalars["Float"]["output"];
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  topic: Topic;
  type: ClassRoomType;
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export type CompleteClassRoom = {
  capacity: Scalars["Int"]["output"];
  conferenceUri: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  feedbackUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1?: Maybe<Scalars["Boolean"]["output"]>;
  meetingUrl: Scalars["String"]["output"];
  participants: Array<CompleteClassRoomParticipant>;
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  teacher: ClassRoomTeacher;
  topic: Topic;
  userGroupId: Scalars["String"]["output"];
};

export type CompleteClassRoomParticipant = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type CreateBulk1on1ClassRoomsResultGraphqlDto = {
  planId: Scalars["String"]["output"];
  requestId: Scalars["String"]["output"];
};

export type CreateBulkClassRoomCreationIntentInput = {
  additionalSlots?: InputMaybe<Array<AdditionalSlotInput>>;
  excludedSlots?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks: Scalars["Int"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
  user1on1ClassroomPlanToBeRedeemedId?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots: Array<WeekSlotInput>;
};

export type CreateOneHourAvailabilitySlotInput = {
  endDateTime?: InputMaybe<Scalars["String"]["input"]>;
  startDateTime: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRecurringAvailabilitySlotInput = {
  daysOfWeek: RepetitionDaysOfWeekInput;
  endDateTime: Scalars["String"]["input"];
  interval: Scalars["Float"]["input"];
  repeatUntil?: InputMaybe<Scalars["String"]["input"]>;
  startDateTime: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateUser1on1ClassroomPlanToBeRedeemedGraphqlInput = {
  totalNumberOfLessons: Scalars["Int"]["input"];
  userId: Scalars["String"]["input"];
};

export type ExhaustedLessonPackStudent = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  lessonPackSize: Scalars["Int"]["output"];
  nextBookedLessonStartUtc?: Maybe<Scalars["String"]["output"]>;
  /** End of the active plan holding the lesson pack */
  planEndUtc: Scalars["String"]["output"];
  /** Speaking level as stored on the user */
  speakingLevel: Scalars["String"]["output"];
  /** Lessons taken or booked, future ones included */
  usedLessons: Scalars["Int"]["output"];
  userGroupName?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
};

export type FailedSubstitutionGraphqlDto = {
  classRoomId: Scalars["String"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  reason: Scalars["String"]["output"];
  startDateUtc: Scalars["DateTimeISO"]["output"];
  teacher?: Maybe<SwappedTeacherInfo>;
};

export type Fps1on1PlanSegment = {
  businessEnglishObjective?: Maybe<Scalars["String"]["output"]>;
  completedLessons: Scalars["Int"]["output"];
  lessonFeedbackReceived: Scalars["Int"]["output"];
  noShows: Scalars["Int"]["output"];
  oneOnOneLessonType?: Maybe<Scalars["String"]["output"]>;
  orderId?: Maybe<Scalars["String"]["output"]>;
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  totalLessons: Scalars["Int"]["output"];
  windowEnd: Scalars["String"]["output"];
  windowStart: Scalars["String"]["output"];
};

export type FpsPlanSegment = {
  completedLessons: Scalars["Int"]["output"];
  lessonFeedbackReceived: Scalars["Int"]["output"];
  noShows: Scalars["Int"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  progressCheckFeedbackReceived: Scalars["Int"]["output"];
  progressCheckNoShows: Scalars["Int"]["output"];
  progressChecksDone: Scalars["Int"]["output"];
  progressChecksFailed: Scalars["Int"]["output"];
  progressChecksPassed: Scalars["Int"]["output"];
  totalLessons: Scalars["Int"]["output"];
  windowEnd: Scalars["String"]["output"];
  windowStart: Scalars["String"]["output"];
};

export type Franchisee = {
  authId: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  internalTeacher?: Maybe<Scalars["Boolean"]["output"]>;
  lesson1on1?: Maybe<Scalars["Boolean"]["output"]>;
  phoneNumber?: Maybe<PhoneNumber>;
  roles: Array<TeacherRole>;
  shiftBaseId: Scalars["String"]["output"];
  tags: Array<TeacherTag>;
  userGroupIds: Array<Scalars["String"]["output"]>;
};

export type FrozenWeekDto = {
  endOfWeekUtc: Scalars["String"]["output"];
  startOfWeekUtc: Scalars["String"]["output"];
};

export type FrozenWeekInput = {
  endOfWeekDate: Scalars["String"]["input"];
  startOfWeekDate: Scalars["String"]["input"];
};

export type GetFreezableWeeksResponse = {
  remainingWeeksToFreeze: Array<RemainingWeeksToFreeze>;
  weeks: Array<WeekWithPlan>;
};

export type GetMyRemainingLessonResponse = {
  cancellationsUsed: Scalars["Int"]["output"];
  maxCancellations?: Maybe<Scalars["Int"]["output"]>;
  planEndDate?: Maybe<Scalars["String"]["output"]>;
  remainingLessons: Scalars["Int"]["output"];
  totalAvailableLessons: Scalars["Int"]["output"];
};

export type GetProgressCheckAvailabilityGraphqlResponse = {
  hasAtLeastOnProgressCheckBookable: Scalars["Boolean"]["output"];
  slots: Array<BookableSlot>;
};

export type GetProgressCheckUserListResponse = {
  participants: Array<ProgressCheckUserDto>;
  progressCheck: ClassRoomWithoutParticipantDto;
};

export type GetSpeakingClassAvailabilityResponse = {
  slots: Array<BookableSlot>;
};

export type GetUserClassRoomCountResponse = {
  totalClassRoomCount: Scalars["Int"]["output"];
};

export type GetUserRemainingLessonCountByWeekResponse = {
  hasUnlimitedLessonsPerWeek: Scalars["Boolean"]["output"];
  remainingLessonCount: Scalars["Int"]["output"];
  totalLessonCount: Scalars["Int"]["output"];
};

export type GiveProgressCheckFeedbackInput = {
  accuracy: Scalars["Int"]["input"];
  comprehension: Scalars["Int"]["input"];
  fluency: Scalars["Int"]["input"];
  noShow?: InputMaybe<Scalars["Boolean"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  passed: Scalars["Boolean"]["input"];
  progressCheckId: Scalars["String"]["input"];
  recommendation: Array<ProgressCheckRecommendation>;
  userId: Scalars["String"]["input"];
  vocabularyRange: Scalars["Int"]["input"];
};

export type HasUnlockedProgressCheckResponse = {
  hasUnlockedProgressCheck: Scalars["Boolean"]["output"];
  lessonCompletedToUnlockProgressCheck: Scalars["Int"]["output"];
  totalLessonNeededToUnlockProgressCheck: Scalars["Int"]["output"];
};

export type InactiveStudent = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  hasActiveGroupPlan: Scalars["Boolean"]["output"];
  hasActiveOneOnOnePlan: Scalars["Boolean"]["output"];
  lastAttendedLessonEndUtc?: Maybe<Scalars["String"]["output"]>;
  /** End of the student's last plan, renewals included */
  lastPlanEndUtc: Scalars["String"]["output"];
  nextBookedLessonStartUtc?: Maybe<Scalars["String"]["output"]>;
  /** Speaking level as stored on the user */
  speakingLevel: Scalars["String"]["output"];
  userGroupName?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
};

export type InactiveStudentStatistics = {
  /** Students with a plan for the whole inactivity window, no paused week in it and no attended lesson in it, longest inactive first */
  inactiveStudents: Array<InactiveStudent>;
  inactivityWindowDays: Scalars["Int"]["output"];
};

export type IntRangeInput = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LessonInfoGraphqlDto = {
  groupId: Scalars["String"]["output"];
  groupName: Scalars["String"]["output"];
  isOneOnOne: Scalars["Boolean"]["output"];
  lessonCount: Scalars["Float"]["output"];
  noShowCount: Scalars["Float"]["output"];
  totalFeedbackReceived: Scalars["Float"]["output"];
};

export type LevelChangeSuggestionDto = {
  id: Scalars["String"]["output"];
  suggestedLevels: Array<SpeakingClassLevel>;
  user: User;
  userId: Scalars["String"]["output"];
};

export type ListClassRoomDateInput = {
  fromDate: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type ListClassRoomResponse = {
  classRooms: Array<ClassRoomListItem>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPrevPage: Scalars["Boolean"]["output"];
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  prevPageToken?: Maybe<Scalars["String"]["output"]>;
};

export type ListUserResponse = {
  hasNextPage: Scalars["Boolean"]["output"];
  hasPrevPage: Scalars["Boolean"]["output"];
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  prevPageToken?: Maybe<Scalars["String"]["output"]>;
  totalCount: Scalars["Int"]["output"];
  users: Array<User>;
};

export type ManualPlanBonusInput = {
  activeFrom?: InputMaybe<Scalars["String"]["input"]>;
  activeTo?: InputMaybe<Scalars["String"]["input"]>;
  extraLessons?: InputMaybe<Scalars["Int"]["input"]>;
  extraWeeks?: InputMaybe<Scalars["Int"]["input"]>;
  lessonsCountedPerWeek?: InputMaybe<Scalars["Int"]["input"]>;
  type: Scalars["String"]["input"];
};

export type Mutation = {
  addFrozenWeek: Scalars["Boolean"]["output"];
  addFrozenWeekToUser: Scalars["Boolean"]["output"];
  addLessonsTo1on1Plan: Scalars["String"]["output"];
  addOnboardingLiveCreationIntentRecurringSlots: OnboardingLiveCreationIntent;
  addOnboardingLiveCreationIntentSlots: OnboardingLiveCreationIntent;
  addParticipantsToClassByEmail: ClassRoom;
  addParticipantsToOnboardingLive: OnboardingLive;
  applyWithdrawalOutcome: Scalars["Boolean"]["output"];
  bookOnboardingLive: MyOnboardingLive;
  bookProgressCheck: Scalars["Boolean"]["output"];
  bookSpeakingClass: Scalars["Boolean"]["output"];
  cancelOnboardingLiveCreationIntent: OnboardingLiveCreationIntent;
  changeOnboardingLiveConductor: OnboardingLiveConductorChangeResult;
  changeOnboardingLiveCreationIntentUserGroup: OnboardingLiveCreationIntent;
  checkOnboardingLiveConductorChange: OnboardingLiveSlotPlan;
  checkOnboardingLiveCreationIntent: OnboardingLiveCreationIntent;
  confirmOnboardingLiveCreationIntent: OnboardingLiveCreationIntent;
  createBulk1on1ClassRooms: CreateBulk1on1ClassRoomsResultGraphqlDto;
  createBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  createClassRoom: ClassRoom;
  createClassRoomPlan: UserClassRoomPlan;
  createFranchisee: Franchisee;
  createOnboardingLiveCreationIntent: OnboardingLiveCreationIntent;
  createOneHourAvailabilitySlot: TeacherAvailabilitySlot;
  createOneOnOneAssignmentPdf: OneOnOneAssignmentPdf;
  createProgressCheckPdf: ProgressCheckPdf;
  createRecurringAvailabilitySlot: Array<TeacherAvailabilitySlot>;
  createSeedUsers: Array<User>;
  createTopic: Topic;
  createUser: User;
  createUser1on1ClassroomPlanToBeRedeemed: User1on1ClassroomPlanToBeRedeemedGraphqlDto;
  createUserGroup: UserGroup;
  delete1on1PlanClassRoomSilently: Scalars["Boolean"]["output"];
  deleteAll1on1PlanFutureClassRoomsSilently: Scalars["Boolean"]["output"];
  deleteAvailabilitySlot: Scalars["Boolean"]["output"];
  deleteBulkClassRoomCreationIntent: Scalars["Boolean"]["output"];
  deleteClassRoom: Scalars["Boolean"]["output"];
  deleteClassRoomPlan: Scalars["Boolean"]["output"];
  deleteLessonFeedback: Scalars["Boolean"]["output"];
  deleteMe: Scalars["Boolean"]["output"];
  deleteOnboardingLive: Scalars["Boolean"]["output"];
  deleteOnboardingLivePdf: Scalars["Boolean"]["output"];
  deleteOneOnOneAssignmentPdf: Scalars["Boolean"]["output"];
  deleteSequenceAvailabilitySlots: Scalars["Boolean"]["output"];
  deleteTeacher: Scalars["Boolean"]["output"];
  detachLastMergedPlan: Array<UserClassRoomPlan>;
  editTopic: Topic;
  enrollUserToAllPaidContent: Scalars["Boolean"]["output"];
  giveOnboardingLiveFeedback: OnboardingLiveFeedback;
  giveProgressCheckFeedback: Scalars["Boolean"]["output"];
  leaveClassRoom: ClassRoomWithoutParticipantDto;
  leaveClassRoomReview: ClassRoomReviewDto;
  leaveOnboardingLive: Scalars["Boolean"]["output"];
  leaveTeacherCoordinatorReview: TeacherCoordinatorReviewDto;
  logicallyDeleteTopic: Scalars["Boolean"]["output"];
  mergeUnlimitedPlans: UserClassRoomPlan;
  recalculateUserClassRoomCounters: Scalars["Boolean"]["output"];
  removeAvailabilitySlot: Scalars["Boolean"]["output"];
  removeFrozenWeek: Scalars["Boolean"]["output"];
  removeFrozenWeekForUser: Scalars["Boolean"]["output"];
  removeOnboardingLiveCreationIntentSlots: OnboardingLiveCreationIntent;
  removeParticipantFromClassRoom: RemoveParticipantFromClassRoomResponse;
  removeParticipantFromOnboardingLive: OnboardingLive;
  requestClassRoomDeletion: Scalars["Boolean"]["output"];
  requestWithdrawal: MyWithdrawalRight;
  resolveLevelSuggestion: Scalars["Boolean"]["output"];
  sendResetPasswordEmail: Scalars["Boolean"]["output"];
  sendUserResetPasswordEmailByUserId: Scalars["Boolean"]["output"];
  setWithdrawalRequestCloserResolution: Scalars["Boolean"]["output"];
  suspendTeacherClassRoomAssignmentUntil: Scalars["Boolean"]["output"];
  swapTeacher: Scalars["Boolean"]["output"];
  try1on1PlanSlotTeacherSubstitution: TeacherSubstitutionResultGraphqlDto;
  try1on1TeacherSubstitution: TeacherSubstitutionResultGraphqlDto;
  updateBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  updateLastLogin: Scalars["Boolean"]["output"];
  updateLatestTeacherCoordinatorReview: TeacherCoordinatorReviewDto;
  updateMe: User;
  updateOnboardingLiveCreationIntentSlot: OnboardingLiveCreationIntent;
  updateTeacher: Franchisee;
  updateUser: User;
  updateUser1on1ClassroomPlanLessonType: User1on1ClassroomPlanGraphqlDto;
  updateUser1on1ClassroomPlanSpeakingLevel: User1on1ClassroomPlanGraphqlDto;
  updateUserClassRoomPlan: UserClassRoomPlan;
  updateUserGroup: UserGroup;
  updateUserLevelToNext: User;
  upsertLessonFeedback: Scalars["Boolean"]["output"];
  upsertOnboardingLivePdf: OnboardingLivePdf;
  upsertOneOnOneAssignmentPdf: Scalars["Boolean"]["output"];
  upsertProgressCheckPdf: Scalars["Boolean"]["output"];
};

export type MutationAddFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type MutationAddFrozenWeekToUserArgs = {
  userId: Scalars["String"]["input"];
  week: FrozenWeekInput;
};

export type MutationAddLessonsTo1on1PlanArgs = {
  planId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput>;
  teacherId: Scalars["String"]["input"];
};

export type MutationAddOnboardingLiveCreationIntentRecurringSlotsArgs = {
  intentId: Scalars["String"]["input"];
  recurrence: OnboardingLiveRecurringSlotsInput;
};

export type MutationAddOnboardingLiveCreationIntentSlotsArgs = {
  intentId: Scalars["String"]["input"];
  slots: Array<OnboardingLiveSlotInput>;
};

export type MutationAddParticipantsToClassByEmailArgs = {
  classRoomId: Scalars["String"]["input"];
  skipLevelCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
  userEmails: Array<Scalars["String"]["input"]>;
};

export type MutationAddParticipantsToOnboardingLiveArgs = {
  onboardingLiveId: Scalars["String"]["input"];
  userEmails: Array<Scalars["String"]["input"]>;
};

export type MutationApplyWithdrawalOutcomeArgs = {
  input: ApplyWithdrawalOutcomeGraphqlInput;
};

export type MutationBookOnboardingLiveArgs = {
  onboardingLiveId: Scalars["String"]["input"];
};

export type MutationBookProgressCheckArgs = {
  bookSlotInput: BookSlotInput;
};

export type MutationBookSpeakingClassArgs = {
  bookSlotInput: BookSlotInput;
};

export type MutationCancelOnboardingLiveCreationIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationChangeOnboardingLiveConductorArgs = {
  makeReplacedConductorAvailableAgain: Scalars["Boolean"]["input"];
  onboardingLiveId: Scalars["String"]["input"];
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationChangeOnboardingLiveCreationIntentUserGroupArgs = {
  intentId: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationCheckOnboardingLiveConductorChangeArgs = {
  onboardingLiveId: Scalars["String"]["input"];
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCheckOnboardingLiveCreationIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationConfirmOnboardingLiveCreationIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCreateBulk1on1ClassRoomsArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCreateBulkClassRoomCreationIntentArgs = {
  input: CreateBulkClassRoomCreationIntentInput;
};

export type MutationCreateClassRoomArgs = {
  capacity: Scalars["Int"]["input"];
  classRoomType: ClassRoomType;
  isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
  participantIds: Array<Scalars["String"]["input"]>;
  speakingLevel: SpeakingClassLevel;
  startUtc: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
};

export type MutationCreateClassRoomPlanArgs = {
  bonuses?: InputMaybe<Array<ManualPlanBonusInput>>;
  endedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  startedAtWeekUtc: Scalars["String"]["input"];
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
  userId: Scalars["String"]["input"];
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
};

export type MutationCreateFranchiseeArgs = {
  email: Scalars["String"]["input"];
  familyName: Scalars["String"]["input"];
  givenName: Scalars["String"]["input"];
  internalTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  phoneNumber: PhoneNumberInput;
  roles?: InputMaybe<Array<TeacherRole>>;
  tags?: InputMaybe<Array<TeacherTag>>;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateOnboardingLiveCreationIntentArgs = {
  userGroupId: Scalars["String"]["input"];
};

export type MutationCreateOneHourAvailabilitySlotArgs = {
  input: CreateOneHourAvailabilitySlotInput;
};

export type MutationCreateOneOnOneAssignmentPdfArgs = {
  assignmentNumber: Scalars["Int"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationCreateProgressCheckPdfArgs = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationCreateRecurringAvailabilitySlotArgs = {
  input: CreateRecurringAvailabilitySlotInput;
};

export type MutationCreateSeedUsersArgs = {
  count: Scalars["Float"]["input"];
  speakingLevel: SpeakingLevel;
};

export type MutationCreateTopicArgs = {
  level: SpeakingClassLevel;
  nameIt: Scalars["String"]["input"];
  pdfUrl: Scalars["String"]["input"];
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateUserArgs = {
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  email: Scalars["String"]["input"];
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOnboardingLiveToBeDone?: InputMaybe<Scalars["Boolean"]["input"]>;
  shouldSendResetPasswordEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevel: SpeakingLevel;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateUser1on1ClassroomPlanToBeRedeemedArgs = {
  input: CreateUser1on1ClassroomPlanToBeRedeemedGraphqlInput;
};

export type MutationCreateUserGroupArgs = {
  availability?: InputMaybe<Array<UserGroupAvailabilityInput>>;
  name: Scalars["String"]["input"];
  onboardingLiveBookingWindowDays?: InputMaybe<Scalars["Int"]["input"]>;
  onboardingLiveRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  thinkificBundleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationDelete1on1PlanClassRoomSilentlyArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type MutationDeleteAll1on1PlanFutureClassRoomsSilentlyArgs = {
  planId: Scalars["String"]["input"];
};

export type MutationDeleteAvailabilitySlotArgs = {
  occurrenceId: Scalars["String"]["input"];
};

export type MutationDeleteBulkClassRoomCreationIntentArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type MutationDeleteClassRoomPlanArgs = {
  planId: Scalars["String"]["input"];
};

export type MutationDeleteLessonFeedbackArgs = {
  lessonFeedbackId: Scalars["String"]["input"];
};

export type MutationDeleteOnboardingLiveArgs = {
  makeConductorAvailableAgain: Scalars["Boolean"]["input"];
  onboardingLiveId: Scalars["String"]["input"];
};

export type MutationDeleteOnboardingLivePdfArgs = {
  userGroupId: Scalars["String"]["input"];
};

export type MutationDeleteOneOnOneAssignmentPdfArgs = {
  assignmentNumber: Scalars["Int"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  userGroupId: Scalars["String"]["input"];
};

export type MutationDeleteSequenceAvailabilitySlotsArgs = {
  occurrenceId: Scalars["String"]["input"];
};

export type MutationDeleteTeacherArgs = {
  teacherId: Scalars["String"]["input"];
};

export type MutationDetachLastMergedPlanArgs = {
  planId: Scalars["String"]["input"];
};

export type MutationEditTopicArgs = {
  id: Scalars["String"]["input"];
  nameIt?: InputMaybe<Scalars["String"]["input"]>;
  pdfUrl?: InputMaybe<Scalars["String"]["input"]>;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationEnrollUserToAllPaidContentArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationGiveOnboardingLiveFeedbackArgs = {
  issues?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  onboardingLiveId: Scalars["String"]["input"];
  participantsCount: Scalars["Int"]["input"];
};

export type MutationGiveProgressCheckFeedbackArgs = {
  input: Array<GiveProgressCheckFeedbackInput>;
};

export type MutationLeaveClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type MutationLeaveClassRoomReviewArgs = {
  classRoomId: Scalars["String"]["input"];
  generalLessonScore: Scalars["Int"]["input"];
  reviewNotes: Scalars["String"]["input"];
  teacherClearanceScore: Scalars["Int"]["input"];
  teacherComfortableScore: Scalars["Int"]["input"];
  teacherInvolvementScore: Scalars["Int"]["input"];
  topicDifficultyScore: Scalars["Int"]["input"];
  topicUsefulnessScore: Scalars["Int"]["input"];
};

export type MutationLeaveOnboardingLiveArgs = {
  onboardingLiveId: Scalars["String"]["input"];
};

export type MutationLeaveTeacherCoordinatorReviewArgs = {
  clarityScore: Scalars["Int"]["input"];
  fluencyScore: Scalars["Int"]["input"];
  presenceScore: Scalars["Int"]["input"];
  teacherId: Scalars["String"]["input"];
};

export type MutationLogicallyDeleteTopicArgs = {
  id: Scalars["String"]["input"];
};

export type MutationMergeUnlimitedPlansArgs = {
  firstPlanId: Scalars["String"]["input"];
  secondPlanId: Scalars["String"]["input"];
};

export type MutationRecalculateUserClassRoomCountersArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationRemoveAvailabilitySlotArgs = {
  slotId: Scalars["String"]["input"];
};

export type MutationRemoveFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type MutationRemoveFrozenWeekForUserArgs = {
  userId: Scalars["String"]["input"];
  week: FrozenWeekInput;
};

export type MutationRemoveOnboardingLiveCreationIntentSlotsArgs = {
  intentId: Scalars["String"]["input"];
  slotIds: Array<Scalars["String"]["input"]>;
};

export type MutationRemoveParticipantFromClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type MutationRemoveParticipantFromOnboardingLiveArgs = {
  onboardingLiveId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type MutationRequestClassRoomDeletionArgs = {
  classId: Scalars["String"]["input"];
};

export type MutationRequestWithdrawalArgs = {
  purchaseKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationResolveLevelSuggestionArgs = {
  suggestionId: Scalars["String"]["input"];
};

export type MutationSendUserResetPasswordEmailByUserIdArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationSetWithdrawalRequestCloserResolutionArgs = {
  input: SetWithdrawalRequestCloserResolutionGraphqlInput;
};

export type MutationSuspendTeacherClassRoomAssignmentUntilArgs = {
  suspendUntilUtc: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
};

export type MutationSwapTeacherArgs = {
  classRoomId: Scalars["String"]["input"];
  doNotMakeOldTeacherAvailableAgain: Scalars["Boolean"]["input"];
  teacherToAddId: Scalars["String"]["input"];
};

export type MutationTry1on1PlanSlotTeacherSubstitutionArgs = {
  planId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput>;
  teacherId: Scalars["String"]["input"];
};

export type MutationTry1on1TeacherSubstitutionArgs = {
  intentId: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateBulkClassRoomCreationIntentArgs = {
  input: UpdateBulkClassRoomCreationIntentInput;
};

export type MutationUpdateLatestTeacherCoordinatorReviewArgs = {
  clarityScore: Scalars["Int"]["input"];
  fluencyScore: Scalars["Int"]["input"];
  presenceScore: Scalars["Int"]["input"];
  teacherId: Scalars["String"]["input"];
};

export type MutationUpdateMeArgs = {
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateOnboardingLiveCreationIntentSlotArgs = {
  intentId: Scalars["String"]["input"];
  slot: OnboardingLiveSlotInput;
  slotId: Scalars["String"]["input"];
};

export type MutationUpdateTeacherArgs = {
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  roles?: InputMaybe<Array<TeacherRole>>;
  tags?: InputMaybe<Array<TeacherTag>>;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationUpdateUserArgs = {
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardingLiveStatus?: InputMaybe<OnboardingLiveStatus>;
  speakingLevel?: InputMaybe<SpeakingLevel>;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type MutationUpdateUser1on1ClassroomPlanLessonTypeArgs = {
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
  id: Scalars["String"]["input"];
  oneOnOneLessonType: OneOnOneLessonType;
};

export type MutationUpdateUser1on1ClassroomPlanSpeakingLevelArgs = {
  id: Scalars["String"]["input"];
  speakingLevel: SpeakingClassLevel;
};

export type MutationUpdateUserClassRoomPlanArgs = {
  bonuses?: InputMaybe<Array<ManualPlanBonusInput>>;
  endedAtWeekUtc?: InputMaybe<Scalars["String"]["input"]>;
  lessonsPerWeek?: InputMaybe<Scalars["Int"]["input"]>;
  planId: Scalars["String"]["input"];
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  startedAtWeekUtc?: InputMaybe<Scalars["String"]["input"]>;
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
};

export type MutationUpdateUserGroupArgs = {
  availability?: InputMaybe<Array<UserGroupAvailabilityInput>>;
  id: Scalars["String"]["input"];
  onboardingLiveBookingWindowDays?: InputMaybe<Scalars["Int"]["input"]>;
  onboardingLiveRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateUserLevelToNextArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationUpsertLessonFeedbackArgs = {
  classRoomId: Scalars["String"]["input"];
  lessonFeedback: Array<UpsertUserLessonFeedbackInput>;
};

export type MutationUpsertOnboardingLivePdfArgs = {
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationUpsertOneOnOneAssignmentPdfArgs = {
  assignmentNumber: Scalars["Int"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationUpsertProgressCheckPdfArgs = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MyOnboardingLive = {
  availableSeats: Scalars["Int"]["output"];
  canBeLeaved: Scalars["Boolean"]["output"];
  endUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isBookedByMe: Scalars["Boolean"]["output"];
  meetingUri?: Maybe<Scalars["String"]["output"]>;
  startUtc: Scalars["String"]["output"];
};

export type MyWithdrawalRequest = {
  id: Scalars["String"]["output"];
  requestedAtUtc: Scalars["String"]["output"];
  status: WithdrawalRequestStatus;
};

export type MyWithdrawalRight = {
  canRequest: Scalars["Boolean"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  planTypes: Array<WithdrawalPlanType>;
  purchaseKey?: Maybe<Scalars["String"]["output"]>;
  purchasedAtUtc: Scalars["String"]["output"];
  request?: Maybe<MyWithdrawalRequest>;
  totalLessons: Scalars["Int"]["output"];
  withdrawalDeadlineUtc: Scalars["String"]["output"];
};

export type NewTeacherCheckInput = {
  createdAt: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
};

export type NewUsersOnDay = {
  /** Day in the requested timezone, as YYYY-MM-DD */
  day: Scalars["String"]["output"];
  userCount: Scalars["Int"]["output"];
};

export type OnboardingLive = {
  capacity: Scalars["Int"]["output"];
  creationIntentId?: Maybe<Scalars["String"]["output"]>;
  deletedAtUtc?: Maybe<Scalars["String"]["output"]>;
  endUtc: Scalars["String"]["output"];
  feedback?: Maybe<OnboardingLiveFeedback>;
  hasEnded: Scalars["Boolean"]["output"];
  hasStarted: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
  participants: Array<ClassRoomParticipant>;
  participantsCount: Scalars["Int"]["output"];
  pdfUrl: Scalars["String"]["output"];
  startUtc: Scalars["String"]["output"];
  teacherId: Scalars["String"]["output"];
  userGroupId: Scalars["String"]["output"];
};

export type OnboardingLiveCancellation = {
  cancelledAtUtc: Scalars["String"]["output"];
  cancelledBy: OnboardingLiveCancelledBy;
  onboardingLiveId: Scalars["String"]["output"];
  onboardingLiveStartUtc: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export enum OnboardingLiveCancelledBy {
  Staff = "Staff",
  Student = "Student",
}

export type OnboardingLiveConductorChange = {
  changedAtUtc: Scalars["String"]["output"];
  fromTeacherId: Scalars["String"]["output"];
  onboardingLiveId: Scalars["String"]["output"];
  onboardingLiveStartUtc: Scalars["String"]["output"];
  toTeacherId: Scalars["String"]["output"];
};

export type OnboardingLiveConductorChangeResult = {
  onboardingLive?: Maybe<OnboardingLive>;
  plan: OnboardingLiveSlotPlan;
};

export type OnboardingLiveCreationIntent = {
  cancelledAtUtc?: Maybe<Scalars["String"]["output"]>;
  cancelledByEmail?: Maybe<Scalars["String"]["output"]>;
  completedAtUtc?: Maybe<Scalars["String"]["output"]>;
  confirmedAtUtc?: Maybe<Scalars["String"]["output"]>;
  confirmedByEmail?: Maybe<Scalars["String"]["output"]>;
  createdAtUtc: Scalars["String"]["output"];
  createdByAuthId: Scalars["String"]["output"];
  createdByEmail?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  lastCheckedAtUtc?: Maybe<Scalars["String"]["output"]>;
  slots: Array<OnboardingLiveCreationIntentSlot>;
  status: OnboardingLiveCreationIntentStatus;
  updatedAtUtc: Scalars["String"]["output"];
  userGroupId: Scalars["String"]["output"];
};

export type OnboardingLiveCreationIntentSlot = {
  creationFailureReason?: Maybe<Scalars["String"]["output"]>;
  creationPlan?: Maybe<OnboardingLiveSlotPlan>;
  creationStatus?: Maybe<OnboardingLiveSlotCreationStatus>;
  endUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lastCheckPlan?: Maybe<OnboardingLiveSlotPlan>;
  onboardingLiveId?: Maybe<Scalars["String"]["output"]>;
  requestedTeacherId?: Maybe<Scalars["String"]["output"]>;
  startUtc: Scalars["String"]["output"];
};

export enum OnboardingLiveCreationIntentStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Confirmed = "Confirmed",
  Draft = "Draft",
}

export type OnboardingLiveFeedback = {
  createdAtUtc: Scalars["String"]["output"];
  issues?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  onboardingLiveId: Scalars["String"]["output"];
  participantsCount: Scalars["Int"]["output"];
  teacherId: Scalars["String"]["output"];
  updatedAtUtc?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingLiveFunnelStatistics = {
  /** Average days between the user creation and the attended live */
  averageDaysToCompleteOnboardingLive?: Maybe<Scalars["Float"]["output"]>;
  /** Median days between the user creation and the attended live */
  medianDaysToCompleteOnboardingLive?: Maybe<Scalars["Float"]["output"]>;
  /** Users who still have to attend an onboarding live and were created more than 7 days ago */
  usersWaitingForMoreThanAWeek: Scalars["Int"]["output"];
  /** Users who completed the onboarding by attending a live in the period */
  usersWhoCompletedOnboardingLive: Scalars["Int"]["output"];
  /** Users who still have to attend an onboarding live */
  usersWithOnboardingLiveToBeDone: Scalars["Int"]["output"];
};

export enum OnboardingLiveListPeriod {
  Past = "Past",
  Upcoming = "Upcoming",
}

export type OnboardingLivePdf = {
  pdfUrl: Scalars["String"]["output"];
  userGroupId: Scalars["String"]["output"];
};

export type OnboardingLivePlanIssue = {
  code: OnboardingLivePlanIssueCode;
  relatedClassRoom?: Maybe<OnboardingLivePlanRelatedClassRoom>;
  relatedTeacherId?: Maybe<Scalars["String"]["output"]>;
  severity: OnboardingLivePlanIssueSeverity;
};

export enum OnboardingLivePlanIssueCode {
  ClassReassignment = "ClassReassignment",
  ConductorAlreadyPlannedAtSameTime = "ConductorAlreadyPlannedAtSameTime",
  ConductorAlreadyRosteredOnShiftbase = "ConductorAlreadyRosteredOnShiftbase",
  ConductorBusyWithClassThatCannotBeReassigned = "ConductorBusyWithClassThatCannotBeReassigned",
  ConductorBusyWithOnboardingLive = "ConductorBusyWithOnboardingLive",
  ConductorBusyWithOneOnOne = "ConductorBusyWithOneOnOne",
  ConductorIsAlreadyTheCurrentOne = "ConductorIsAlreadyTheCurrentOne",
  ConductorNotEnabledForOnboardingLives = "ConductorNotEnabledForOnboardingLives",
  ConductorNotFound = "ConductorNotFound",
  ForcedRoster = "ForcedRoster",
  MissingOnboardingLivePdf = "MissingOnboardingLivePdf",
  NoConductorAvailable = "NoConductorAvailable",
  OtherUserGroupSameDay = "OtherUserGroupSameDay",
  SameUserGroupSameDay = "SameUserGroupSameDay",
  SameUserGroupSameHour = "SameUserGroupSameHour",
  SlotInThePast = "SlotInThePast",
  SlotNotOneHourLong = "SlotNotOneHourLong",
  SlotOutsideUserGroupAvailability = "SlotOutsideUserGroupAvailability",
  UserGroupWithoutOnboardingLives = "UserGroupWithoutOnboardingLives",
}

export enum OnboardingLivePlanIssueSeverity {
  Blocking = "Blocking",
  Notice = "Notice",
  Warning = "Warning",
}

export type OnboardingLivePlanRelatedClassRoom = {
  endUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1: Scalars["Boolean"]["output"];
  startUtc: Scalars["String"]["output"];
  teacherId: Scalars["String"]["output"];
  type: ClassRoomType;
  userGroupId: Scalars["String"]["output"];
};

export type OnboardingLiveReassignment = {
  classRoomId: Scalars["String"]["output"];
  fromTeacherId: Scalars["String"]["output"];
  toTeacherId: Scalars["String"]["output"];
};

export type OnboardingLiveRecurringSlotsInput = {
  fromDate: Scalars["String"]["input"];
  startTimes: Array<Scalars["String"]["input"]>;
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
  toDate: Scalars["String"]["input"];
  weekDays: Array<WeekDayEnum>;
};

export enum OnboardingLiveRestriction {
  GroupLessonsOnly = "GroupLessonsOnly",
  None = "None",
  WholePlatform = "WholePlatform",
}

export enum OnboardingLiveSlotCreationStatus {
  Created = "Created",
  Failed = "Failed",
  Pending = "Pending",
  Processing = "Processing",
}

export type OnboardingLiveSlotInput = {
  startUtc: Scalars["String"]["input"];
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
};

export type OnboardingLiveSlotPlan = {
  forcedRoster: Scalars["Boolean"]["output"];
  issues: Array<OnboardingLivePlanIssue>;
  reassignment?: Maybe<OnboardingLiveReassignment>;
  slotId: Scalars["String"]["output"];
  status: OnboardingLiveSlotPlanStatus;
  teacherId?: Maybe<Scalars["String"]["output"]>;
};

export enum OnboardingLiveSlotPlanStatus {
  Blocked = "Blocked",
  Ok = "Ok",
  Warning = "Warning",
}

export type OnboardingLiveStatisticsRecords = {
  cancellations: Array<OnboardingLiveCancellation>;
  conductorChanges: Array<OnboardingLiveConductorChange>;
  deletedLives: Array<OnboardingLive>;
  lives: Array<OnboardingLive>;
};

export enum OnboardingLiveStatus {
  Completed = "Completed",
  ToBeDone = "ToBeDone",
}

export type OneOnOneAssignmentPdf = {
  assignmentNumber: Scalars["Int"]["output"];
  businessEnglishObjective?: Maybe<BusinessEnglishObjective>;
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  pdfUrl: Scalars["String"]["output"];
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export enum OneOnOneLessonType {
  BusinessEnglish = "BusinessEnglish",
  GeneralEnglish = "GeneralEnglish",
}

export type OneOnOnePlanPurchaseGraphqlDto = {
  hasActiveGroupPlan: Scalars["Boolean"]["output"];
  lastGroupPlanEndDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  onboardingFormCompleted: Scalars["Boolean"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  purchasedAt: Scalars["DateTimeISO"]["output"];
  userEmail: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type PhoneNumber = {
  countryCode: Scalars["String"]["output"];
  number: Scalars["String"]["output"];
};

export type PhoneNumberInput = {
  countryCode: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
};

export type Plan1on1BookedClassRoomGraphqlDto = {
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  startedAtUtc: Scalars["String"]["output"];
};

export type Plan1on1ManagementInfoGraphqlDto = {
  bookedClassRooms: Array<Plan1on1BookedClassRoomGraphqlDto>;
  teacherId?: Maybe<Scalars["String"]["output"]>;
};

export type PlanMergeHistoryEntry = {
  bonuses?: Maybe<Array<UserClassRoomPlanBonus>>;
  mergedAtUtc: Scalars["String"]["output"];
  premergeEndedAtWeekUtc: Scalars["String"]["output"];
  premergeTotalLessons: Scalars["Float"]["output"];
  promoIds?: Maybe<Array<Scalars["String"]["output"]>>;
  triggeringOrderId?: Maybe<Scalars["String"]["output"]>;
};

export type ProgressCheckPdf = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["output"];
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export enum ProgressCheckRecommendation {
  MoreAccuracy = "MoreAccuracy",
  MoreFluency = "MoreFluency",
  MoreImmersion = "MoreImmersion",
  MoreVocabulary = "MoreVocabulary",
}

export type ProgressCheckResultDto = {
  accuracy: Scalars["Int"]["output"];
  comprehension: Scalars["Int"]["output"];
  fluency: Scalars["Int"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  passed: Scalars["Boolean"]["output"];
  progressCheckId: Scalars["String"]["output"];
  progressCheckLevel: SpeakingClassLevel;
  progressCheckStartedAtUtc: Scalars["String"]["output"];
  recommendation: Array<ProgressCheckRecommendation>;
  teacher: ClassRoomTeacher;
  teacherId: Scalars["String"]["output"];
  toLevel?: Maybe<SpeakingClassLevel>;
  userId: Scalars["String"]["output"];
  vocabularyRange: Scalars["Int"]["output"];
};

export type ProgressCheckTopic = {
  level: SpeakingClassLevel;
  pdfUri: Scalars["String"]["output"];
};

export type ProgressCheckUserDto = {
  alreadyGivenFeedback: Scalars["Boolean"]["output"];
  canImproveSpeakingLevel: Scalars["Boolean"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  shouldPassPcDueToStarter: Scalars["Boolean"]["output"];
};

/** The type of promo bonus applied to a user class room plan */
export enum PromoBonusType {
  AllYouCanSpeak = "AllYouCanSpeak",
  ExtraLessons = "ExtraLessons",
  ExtraWeeks = "ExtraWeeks",
}

export type Query = {
  adminGetClassRoomById: CompleteClassRoom;
  calculateBulkClassRoomCreationSlots: Array<CalculatedSlot>;
  calculatePlanGivenSlotByParams: Scalars["Int"]["output"];
  check1on1PlanSlotConflicts: Array<CalculatedSlot>;
  checkUserHasSpeakingLevel?: Maybe<Scalars["Boolean"]["output"]>;
  get1on1PlanManagementInfo: Plan1on1ManagementInfoGraphqlDto;
  getActiveIntentsForStudent: Array<BulkClassRoomCreationIntent>;
  getAllActiveUsersByIds: Array<Maybe<User>>;
  getAllBulkClassRoomCreationIntents: Array<BulkClassRoomCreationIntent>;
  getAllBulkClassRoomCreationRequests: Array<BulkClassRoomCreationRequestGraphqlDto>;
  getAllByShiftBaseUserIds: Array<Franchisee>;
  getAllFranchisees: Array<Franchisee>;
  getAllOnboardingLivePdfs: Array<OnboardingLivePdf>;
  getAllOneOnOneAssignmentPdfs: Array<OneOnOneAssignmentPdf>;
  getAllProgressCheckPdfs: Array<ProgressCheckPdf>;
  getAllTeacherByIds: Array<Franchisee>;
  getAllTopics: Array<Topic>;
  getAllUserGroups: Array<UserGroup>;
  getAllUsersByIds: Array<Maybe<User>>;
  getAvailabilityByTeacherForWeek: Array<AvailabilitySlotDto>;
  getAvailabilityForProgressCheck: GetProgressCheckAvailabilityGraphqlResponse;
  getAvailabilityForSpeakingClass: GetSpeakingClassAvailabilityResponse;
  getAvailableTeacherSlots: Array<AvailableTeacherSlot>;
  getAvailableTeachersInHour: Array<ClassRoomTeacher>;
  getBookedClassRooms: Array<BookedClassRoom>;
  getBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  getBulkClassRoomCreationRequest?: Maybe<BulkClassRoomCreationRequestGraphqlDto>;
  getByAuthId: User;
  getClassRoomById: ClassRoom;
  getClassRoomByIdV2: ClassRoomV2;
  getClassRoomPlanByIdAndUserId: UserClassRoomPlan;
  getClassRoomSelectionDetail?: Maybe<ClassRoomSelectionDetail>;
  getClassRoomSelectionHistory: Array<ClassRoomSelectionHistoryEntry>;
  getClassRoomsByTeacherAndDateRange: Array<ClassRoomV2>;
  getClassRoomsWhereTeacherWasCandidate: Array<Scalars["String"]["output"]>;
  getCurrentLoggedInTeacherAvailability: Array<TeacherAvailabilitySlot>;
  getFirstPassedProgressCheckResultByUserIds: Array<ProgressCheckResultDto>;
  getFranchiseeById: Franchisee;
  getFreezableWeeks: GetFreezableWeeksResponse;
  getFreezableWeeksByUser: GetFreezableWeeksResponse;
  getFrozenWeeksByUser: Array<FrozenWeekDto>;
  getIdsOfUsersEligibleForRLCWarranty: Array<Scalars["String"]["output"]>;
  getInactiveStudentStatistics: InactiveStudentStatistics;
  getLessonFeedbackReportByUser: UserLessonFeedbackReport;
  getLoggedTeacher: Franchisee;
  getMinUsedTopicsInLevelAmongParticipants: Array<Topic>;
  getMyAllYouCanSpeakBonusStatus: AllYouCanSpeakBonusStatus;
  getMyClassRoomsWithMissingFeedback: Array<ClassRoomWithMissingFeedback>;
  getMyFrozenWeeks: Array<FrozenWeekDto>;
  getMyRemaining1on1Lessons?: Maybe<GetMyRemainingLessonResponse>;
  getMyRemainingLessons: GetMyRemainingLessonResponse;
  getMyWorkedHoursOfAMonth: Array<WorkedHour>;
  getNewTeacherIds: Array<Scalars["String"]["output"]>;
  getOnboardingLiveById: OnboardingLive;
  getOnboardingLiveCreationIntent: OnboardingLiveCreationIntent;
  getOnboardingLiveCreationIntents: Array<OnboardingLiveCreationIntent>;
  getOnboardingLiveFeedback?: Maybe<OnboardingLiveFeedback>;
  getOnboardingLiveFunnelStatistics: OnboardingLiveFunnelStatistics;
  getOnboardingLiveStatisticsRecords: OnboardingLiveStatisticsRecords;
  getOnboardingLives: Array<OnboardingLive>;
  getOneOnOneClassRoomsByUserId: Array<ClassRoomV2>;
  getOneOnOnePlanPurchases: Array<OneOnOnePlanPurchaseGraphqlDto>;
  getProgressCheckResultByUserId: Array<ProgressCheckResultDto>;
  getProgressCheckUserList: GetProgressCheckUserListResponse;
  getStudentPlanStatistics: StudentPlanStatistics;
  getTeacherAssignmentCapOverview: TeacherAssignmentCapOverview;
  getTeacherByAuthId: Franchisee;
  getTeacherClassRooms: Array<ClassRoomWithoutParticipantDto>;
  getTeacherCoordinatorReviewHistory: Array<TeacherCoordinatorReviewDto>;
  getTeacherCoordinatorReviews: Array<TeacherCoordinatorReviewDto>;
  getTeacherFutureClassRooms: Array<ClassRoomV2>;
  getTeacherScore: TeacherScoreDto;
  getTeacherScores: Array<TeacherScoreWithIdDto>;
  getTeacherStudentReviewCounts: Array<TeacherStudentReviewCountDto>;
  getTeacherStudentReviews: TeacherStudentReviewsResultDto;
  getTeacherWeekAssignmentCap: TeacherWeekAssignmentCap;
  getTeachersWithLimitedAvailabilitySlots: Array<Franchisee>;
  getTeachersWithMissingFeedback: Array<TeacherWithMissingFeedback>;
  getTopicById: Topic;
  getUser1on1ClassroomPlans: Array<User1on1ClassroomPlanGraphqlDto>;
  getUser1on1ClassroomPlansToBeRedeemed: Array<User1on1ClassroomPlanToBeRedeemedGraphqlDto>;
  getUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanId: Array<User1on1ClassroomPlanToBeRedeemedGraphqlDto>;
  /** Lesson and feedback counters of every user with at least one lesson or feedback. Users not listed have all counters at zero. */
  getUserActivityCounters: Array<UserActivityCounters>;
  getUserByEmailEvenIfDeleted: User;
  getUserById: User;
  getUserClassRoomCount: GetUserClassRoomCountResponse;
  getUserClassRoomHistory: Array<UserClassRoomHistoryItem>;
  getUserClassRoomPlans: Array<UserClassRoomPlan>;
  getUserClassRoomsBetweenDates: Array<ClassRoomWithoutParticipantDto>;
  getUserGroupAvailableDays: AvailableWeekDayForGroup;
  getUserIdsWithActive1on1Plans: Array<Scalars["String"]["output"]>;
  getUserIdsWithActiveGroupPlans: Array<Scalars["String"]["output"]>;
  getUserLessonsInfo: UserLessonsInfoGraphqlDto;
  getUserRemainingLessonByWeek: GetUserRemainingLessonCountByWeekResponse;
  getUserRemainingLessons: Scalars["Int"]["output"];
  getUserStatistics: UserStatistics;
  getUsersEligibleForWarranty: Array<User>;
  hasSpeakingEnabled: Scalars["Boolean"]["output"];
  hasUnlockedProgressCheck: HasUnlockedProgressCheckResponse;
  isActiveUser: Scalars["Boolean"]["output"];
  isActiveUserForAdminById: Scalars["Boolean"]["output"];
  isFrozenWeek: Scalars["Boolean"]["output"];
  listAllUsers: ListUserResponse;
  listClassRooms: ListClassRoomResponse;
  listNotResolvedLevelChangeSuggestions: Array<LevelChangeSuggestionDto>;
  me?: Maybe<User>;
  myBookableOnboardingLives: Array<MyOnboardingLive>;
  myBookedOnboardingLive?: Maybe<MyOnboardingLive>;
  myWithdrawalRights: Array<MyWithdrawalRight>;
  myWorkedHoursByMonth: Array<WorkedHoursByMonthItem>;
  safelyGetUserByEmail?: Maybe<User>;
  searchTeachersByEmail: Array<Franchisee>;
  speakingClassServiceAgGridQuery: AgGridQueryResponse;
  userActivePlansStatus: UserActivePlansStatus;
};

export type QueryAdminGetClassRoomByIdArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryCalculateBulkClassRoomCreationSlotsArgs = {
  input: CalculateBulkClassRoomCreationSlotsInput;
};

export type QueryCalculatePlanGivenSlotByParamsArgs = {
  endedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  startedAtWeekUtc: Scalars["String"]["input"];
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
};

export type QueryCheck1on1PlanSlotConflictsArgs = {
  planId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput>;
  teacherId: Scalars["String"]["input"];
};

export type QueryCheckUserHasSpeakingLevelArgs = {
  email: Scalars["String"]["input"];
};

export type QueryGet1on1PlanManagementInfoArgs = {
  planId: Scalars["String"]["input"];
};

export type QueryGetActiveIntentsForStudentArgs = {
  studentId: Scalars["String"]["input"];
};

export type QueryGetAllActiveUsersByIdsArgs = {
  userIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryGetAllBulkClassRoomCreationIntentsArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryGetAllByShiftBaseUserIdsArgs = {
  shiftBaseUserIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetAllFranchiseesArgs = {
  isInternal?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetAllTeacherByIdsArgs = {
  ids: Array<Scalars["String"]["input"]>;
};

export type QueryGetAllUsersByIdsArgs = {
  userIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryGetAvailabilityByTeacherForWeekArgs = {
  fromDate: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailabilityForProgressCheckArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailabilityForSpeakingClassArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailableTeacherSlotsArgs = {
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailableTeachersInHourArgs = {
  startUtc: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
};

export type QueryGetBookedClassRoomsArgs = {
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetBulkClassRoomCreationIntentArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetBulkClassRoomCreationRequestArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetByAuthIdArgs = {
  authId: Scalars["String"]["input"];
};

export type QueryGetClassRoomByIdArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomByIdV2Args = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomPlanByIdAndUserIdArgs = {
  planId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type QueryGetClassRoomSelectionDetailArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomSelectionHistoryArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomsByTeacherAndDateRangeArgs = {
  endUtc: Scalars["String"]["input"];
  startUtc: Scalars["String"]["input"];
};

export type QueryGetClassRoomsWhereTeacherWasCandidateArgs = {
  classRoomIds: Array<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
};

export type QueryGetCurrentLoggedInTeacherAvailabilityArgs = {
  maxDateString: Scalars["String"]["input"];
  minDateString: Scalars["String"]["input"];
};

export type QueryGetFirstPassedProgressCheckResultByUserIdsArgs = {
  userIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetFranchiseeByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetFreezableWeeksByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetFrozenWeeksByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetIdsOfUsersEligibleForRlcWarrantyArgs = {
  plansEndAfter?: InputMaybe<Scalars["String"]["input"]>;
  plansEndBefore?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetLessonFeedbackReportByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetMinUsedTopicsInLevelAmongParticipantsArgs = {
  participantIds: Array<Scalars["String"]["input"]>;
  speakingLevel: SpeakingClassLevel;
};

export type QueryGetMyAllYouCanSpeakBonusStatusArgs = {
  clientTimezone: Scalars["String"]["input"];
  dateUtc: Scalars["String"]["input"];
};

export type QueryGetMyWorkedHoursOfAMonthArgs = {
  clientTimezone: Scalars["String"]["input"];
  monthStartDateTimeUtc: Scalars["String"]["input"];
};

export type QueryGetNewTeacherIdsArgs = {
  checks: Array<NewTeacherCheckInput>;
};

export type QueryGetOnboardingLiveByIdArgs = {
  onboardingLiveId: Scalars["String"]["input"];
};

export type QueryGetOnboardingLiveCreationIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type QueryGetOnboardingLiveFeedbackArgs = {
  onboardingLiveId: Scalars["String"]["input"];
};

export type QueryGetOnboardingLiveFunnelStatisticsArgs = {
  fromUtc: Scalars["String"]["input"];
  toUtc: Scalars["String"]["input"];
};

export type QueryGetOnboardingLiveStatisticsRecordsArgs = {
  fromUtc: Scalars["String"]["input"];
  toUtc: Scalars["String"]["input"];
};

export type QueryGetOnboardingLivesArgs = {
  period: OnboardingLiveListPeriod;
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOneOnOneClassRoomsByUserIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetOneOnOnePlanPurchasesArgs = {
  onboardingFormCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetProgressCheckResultByUserIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetProgressCheckUserListArgs = {
  progressCheckId: Scalars["String"]["input"];
};

export type QueryGetTeacherAssignmentCapOverviewArgs = {
  teacherId: Scalars["String"]["input"];
  upcomingWeeks: Scalars["Int"]["input"];
};

export type QueryGetTeacherByAuthIdArgs = {
  authId: Scalars["String"]["input"];
};

export type QueryGetTeacherClassRoomsArgs = {
  fromDate: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetTeacherCoordinatorReviewHistoryArgs = {
  teacherId: Scalars["String"]["input"];
};

export type QueryGetTeacherCoordinatorReviewsArgs = {
  teacherIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetTeacherFutureClassRoomsArgs = {
  teacherId: Scalars["String"]["input"];
};

export type QueryGetTeacherScoreArgs = {
  teacherId: Scalars["String"]["input"];
};

export type QueryGetTeacherScoresArgs = {
  teacherIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetTeacherStudentReviewCountsArgs = {
  teacherIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetTeacherStudentReviewsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
};

export type QueryGetTeacherWeekAssignmentCapArgs = {
  teacherId: Scalars["String"]["input"];
  weekDate: Scalars["String"]["input"];
};

export type QueryGetTopicByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetUser1on1ClassroomPlansArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUser1on1ClassroomPlansToBeRedeemedArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdArgs =
  {
    limit?: Scalars["Int"]["input"];
    offset?: Scalars["Int"]["input"];
  };

export type QueryGetUserByEmailEvenIfDeletedArgs = {
  email: Scalars["String"]["input"];
};

export type QueryGetUserByIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserClassRoomHistoryArgs = {
  includeUpcoming?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type QueryGetUserClassRoomPlansArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserClassRoomsBetweenDatesArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetUserIdsWithActive1on1PlansArgs = {
  oneOnOneLessonType?: InputMaybe<OneOnOneLessonType>;
};

export type QueryGetUserLessonsInfoArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserRemainingLessonByWeekArgs = {
  clientTimezone: Scalars["String"]["input"];
  dateUtc: Scalars["String"]["input"];
};

export type QueryGetUserRemainingLessonsArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserStatisticsArgs = {
  fromDay: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDay: Scalars["String"]["input"];
};

export type QueryGetUsersEligibleForWarrantyArgs = {
  plansEndAfter?: InputMaybe<Scalars["String"]["input"]>;
  plansEndBefore?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryIsActiveUserForAdminByIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryIsFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type QueryListAllUsersArgs = {
  activityRanges?: InputMaybe<UserActivityRangesInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  groupUserGroupId?: InputMaybe<Scalars["String"]["input"]>;
  hasGroupPlanActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasOneOnOneActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit: Scalars["Int"]["input"];
  nextPageToken?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  oneOnOneLessonType?: InputMaybe<OneOnOneLessonType>;
  prevPageToken?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<UserListSortField>;
  sortDirection?: InputMaybe<UserListSortDirection>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
  withSpeakingLevel?: InputMaybe<Array<InputMaybe<SpeakingLevel>>>;
};

export type QueryListClassRoomsArgs = {
  dateRange?: InputMaybe<ListClassRoomDateInput>;
  limit: Scalars["Int"]["input"];
  nextToken?: InputMaybe<Scalars["String"]["input"]>;
  prevToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryMyWorkedHoursByMonthArgs = {
  clientTimezone: Scalars["String"]["input"];
  endDateUtc: Scalars["String"]["input"];
  startDateUtc: Scalars["String"]["input"];
};

export type QuerySafelyGetUserByEmailArgs = {
  email: Scalars["String"]["input"];
};

export type QuerySearchTeachersByEmailArgs = {
  filter: Scalars["String"]["input"];
};

export type QuerySpeakingClassServiceAgGridQueryArgs = {
  params: AgGridParamsInput;
};

export type RemainingWeeksToFreeze = {
  planId: Scalars["String"]["output"];
  remainingCount: Scalars["Float"]["output"];
};

export type RemoveParticipantFromClassRoomResponse = {
  classRoom: ClassRoom;
  classRoomDeleted: Scalars["Boolean"]["output"];
};

export type RepetitionDaysOfWeekInput = {
  fr: Scalars["Boolean"]["input"];
  mo: Scalars["Boolean"]["input"];
  sa: Scalars["Boolean"]["input"];
  su: Scalars["Boolean"]["input"];
  th: Scalars["Boolean"]["input"];
  tu: Scalars["Boolean"]["input"];
  we: Scalars["Boolean"]["input"];
};

export type SetWithdrawalRequestCloserResolutionGraphqlInput = {
  closerEmail?: InputMaybe<Scalars["String"]["input"]>;
  closerName?: InputMaybe<Scalars["String"]["input"]>;
  closerTeamName?: InputMaybe<Scalars["String"]["input"]>;
  dealId?: InputMaybe<Scalars["String"]["input"]>;
  notificationRecipient?: InputMaybe<WithdrawalNotificationRecipient>;
  notifiedAtUtc?: InputMaybe<Scalars["String"]["input"]>;
  requestId: Scalars["String"]["input"];
  teamLeaderEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SpeakingClassLevel {
  Explorers = "Explorers",
  Navigators = "Navigators",
  Pioneers = "Pioneers",
  Starters = "Starters",
  Voyagers = "Voyagers",
}

/** The user speaking level */
export enum SpeakingLevel {
  Explorers = "Explorers",
  Navigators = "Navigators",
  Pioneers = "Pioneers",
  Starters = "Starters",
  Unknown = "Unknown",
  Voyagers = "Voyagers",
}

export type StudentLevelCount = {
  /** Speaking level as stored on the user */
  speakingLevel: Scalars["String"]["output"];
  studentCount: Scalars["Int"]["output"];
};

export type StudentPlanStatistics = {
  activeGroupPlanStudentCount: Scalars["Int"]["output"];
  activeOneOnOnePlanStudentCount: Scalars["Int"]["output"];
  /** Students with a group plan, a 1to1 plan or both */
  activePlanStudentCount: Scalars["Int"]["output"];
  activePlanStudentsByLevel: Array<StudentLevelCount>;
  /** @deprecated Moved to getInactiveStudentStatistics */
  inactiveStudents: Array<InactiveStudent>;
  /** @deprecated Moved to getInactiveStudentStatistics */
  inactivityWindowDays: Scalars["Int"]["output"];
  planEndingWithinDays: Scalars["Int"]["output"];
  /** Students whose active group plan has unlimited lessons per week from a lesson pack, with no lesson left to book and no upcoming group plan, latest ending plan first */
  studentsWithExhaustedLessonPack: Array<ExhaustedLessonPackStudent>;
  /** Students whose last plan is a group plan ending within planEndingWithinDays */
  studentsWithGroupPlanEndingSoonCount: Scalars["Int"]["output"];
  /** Students whose last plan is a 1to1 plan ending within planEndingWithinDays */
  studentsWithOneOnOnePlanEndingSoonCount: Scalars["Int"]["output"];
};

export type SuccessfulSubstitutionGraphqlDto = {
  classRoomId: Scalars["String"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  isOnboardingLive: Scalars["Boolean"]["output"];
  newTeacher: SwappedTeacherInfo;
  originalTeacher: SwappedTeacherInfo;
  startDateUtc: Scalars["DateTimeISO"]["output"];
};

export type SwappedTeacherInfo = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lesson1on1: Scalars["Boolean"]["output"];
};

export type TeacherAssignmentCapOverview = {
  finalScore: Scalars["Float"]["output"];
  maxPercentOfWeeklyAvailability: Scalars["Int"]["output"];
  tier: TeacherTier;
  weeks: Array<TeacherAssignmentCapWeek>;
};

export type TeacherAssignmentCapWeek = {
  assignedClassRooms: Scalars["Int"]["output"];
  hasBeenReached: Scalars["Boolean"]["output"];
  maxAssignableClassRooms: Scalars["Int"]["output"];
  offeredSlots: Scalars["Int"]["output"];
  weekEndUtc: Scalars["String"]["output"];
  weekStartUtc: Scalars["String"]["output"];
};

export type TeacherAvailabilitySlot = {
  endDateTime: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  recurring: Scalars["Boolean"]["output"];
  slotTimezone: Scalars["String"]["output"];
  startDateTime: Scalars["String"]["output"];
};

export type TeacherCoordinatorReviewDto = {
  id: Scalars["String"]["output"];
  reviewedAtUtc: Scalars["String"]["output"];
  scores: TeacherCoordinatorReviewScoresDto;
  teacherId: Scalars["String"]["output"];
};

export type TeacherCoordinatorReviewScoresDto = {
  clarityScore: Scalars["Int"]["output"];
  fluencyScore: Scalars["Int"]["output"];
  presenceScore: Scalars["Int"]["output"];
};

export enum TeacherRole {
  NormaStaff = "NormaStaff",
  Teacher = "Teacher",
}

export type TeacherScoreDto = {
  coordinatorScore?: Maybe<Scalars["Float"]["output"]>;
  finalScore: Scalars["Float"]["output"];
  studentBayesianAvg: Scalars["Float"]["output"];
};

export type TeacherScoreWithIdDto = {
  coordinatorScore?: Maybe<Scalars["Float"]["output"]>;
  finalScore: Scalars["Float"]["output"];
  studentBayesianAvg: Scalars["Float"]["output"];
  teacherId: Scalars["String"]["output"];
};

export type TeacherStudentReviewCountDto = {
  teacherId: Scalars["String"]["output"];
  totalReviews: Scalars["Int"]["output"];
};

export type TeacherStudentReviewGroupDto = {
  decayedAvg: Scalars["Float"]["output"];
  reviews: Array<TeacherStudentReviewItemDto>;
  userId: Scalars["String"]["output"];
};

export type TeacherStudentReviewItemDto = {
  clearanceScore: Scalars["Int"]["output"];
  comfortableScore: Scalars["Int"]["output"];
  decayWeight: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  involvementScore: Scalars["Int"]["output"];
  reviewedAtUtc: Scalars["String"]["output"];
  teacherAvg: Scalars["Float"]["output"];
};

export type TeacherStudentReviewsResultDto = {
  simulatedStudentScore: Scalars["Float"]["output"];
  students: Array<TeacherStudentReviewGroupDto>;
};

export type TeacherSubstitutionResultGraphqlDto = {
  failedSubstitutions: Array<FailedSubstitutionGraphqlDto>;
  successfulSubstitutions: Array<SuccessfulSubstitutionGraphqlDto>;
};

export enum TeacherTag {
  OnboardingLive = "OnboardingLive",
}

export enum TeacherTier {
  BelowStandard = "BelowStandard",
  Elite = "Elite",
  MeetsStandard = "MeetsStandard",
  Strong = "Strong",
  TopPerformer = "TopPerformer",
}

export type TeacherWeekAssignmentCap = {
  assignedClassRooms: Scalars["Int"]["output"];
  offeredSlots: Scalars["Int"]["output"];
  weekEndUtc: Scalars["String"]["output"];
  weekStartUtc: Scalars["String"]["output"];
  weeklyCapWithCurrentTier?: Maybe<TeacherWeeklyAssignmentCap>;
};

export type TeacherWeeklyAssignmentCap = {
  assignedClassRooms: Scalars["Int"]["output"];
  hasBeenReached: Scalars["Boolean"]["output"];
  maxAssignableClassRooms: Scalars["Int"]["output"];
  maxPercentOfWeeklyAvailability: Scalars["Int"]["output"];
  offeredSlots: Scalars["Int"]["output"];
  tier: TeacherTier;
};

export type TeacherWithMissingFeedback = {
  classRoomsWithMissingFeedback: Array<ClassRoomWithMissingFeedback>;
  teacherId: Scalars["String"]["output"];
};

export type TimeInterval = {
  from: Scalars["Int"]["output"];
  to: Scalars["Int"]["output"];
};

export type TimeIntervalInput = {
  from: Scalars["Int"]["input"];
  to: Scalars["Int"]["input"];
};

export type Topic = {
  id: Scalars["String"]["output"];
  level: SpeakingClassLevel;
  name: Scalars["String"]["output"];
  pdfUrl: Scalars["String"]["output"];
  userGroupIds: Array<Scalars["String"]["output"]>;
  userGroups: Array<UserGroup>;
};

export type UnlimitedLessonPerWeekEnabledInput = {
  enabled: Scalars["Boolean"]["input"];
  totalLessons?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateBulkClassRoomCreationIntentInput = {
  additionalSlots?: InputMaybe<Array<AdditionalSlotInput>>;
  excludedSlots?: InputMaybe<Array<Scalars["String"]["input"]>>;
  id: Scalars["String"]["input"];
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
  user1on1ClassroomPlanToBeRedeemedId?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots?: InputMaybe<Array<WeekSlotInput>>;
};

export type UpsertUserLessonFeedbackInput = {
  differentSpeakingLevelSuggested?: InputMaybe<SpeakingClassLevel>;
  noShow: Scalars["Boolean"]["input"];
  notes: Scalars["String"]["input"];
  participationScore: Scalars["Int"]["input"];
  targetLanguageScore: Scalars["Int"]["input"];
  userId: Scalars["String"]["input"];
};

export type User = {
  authId: Scalars["String"]["output"];
  completedOnboardingLiveId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  firstPlanStartDate?: Maybe<Scalars["String"]["output"]>;
  fps1on1PlanSegments: Array<Fps1on1PlanSegment>;
  fpsPlanSegments: Array<FpsPlanSegment>;
  givenName: Scalars["String"]["output"];
  hideBookProgressCheckSection: Scalars["Boolean"]["output"];
  hideBookSpeakingClassSection: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  lastPlanEndDate?: Maybe<Scalars["String"]["output"]>;
  lastSelfAssessmentLevel: SpeakingLevel;
  lessonFeedbacks: Array<UserLessonFeedbackDto>;
  mustAttendOnboardingLive: Scalars["Boolean"]["output"];
  onboardingLiveCompletedAt?: Maybe<Scalars["String"]["output"]>;
  onboardingLiveRestriction: OnboardingLiveRestriction;
  onboardingLiveStatus?: Maybe<OnboardingLiveStatus>;
  onboardingLiveStatusUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  onboardingLiveStatusUpdatedByAuthId?: Maybe<Scalars["String"]["output"]>;
  onboardingLiveStatusUpdatedByEmail?: Maybe<Scalars["String"]["output"]>;
  partecipatedProgressCheckCount: Scalars["Int"]["output"];
  partecipatedSpeakingClassCount: Scalars["Int"]["output"];
  progressCheckResults: Array<ProgressCheckResultDto>;
  speakingLevel: SpeakingLevel;
  startingSpeakingLevel: SpeakingLevel;
  userGroup: UserGroup;
};

export type User1on1ClassroomPlanGraphqlDto = {
  businessEnglishObjective?: Maybe<BusinessEnglishObjective>;
  createdAt: Scalars["DateTimeISO"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  id: Scalars["String"]["output"];
  lastLessonDateUtc?: Maybe<Scalars["DateTimeISO"]["output"]>;
  lessonsPerWeek: Scalars["Float"]["output"];
  numberOfWeeks: Scalars["Float"]["output"];
  oneOnOneLessonType?: Maybe<OneOnOneLessonType>;
  speakingLevel?: Maybe<SpeakingClassLevel>;
  startDateUtc: Scalars["DateTimeISO"]["output"];
  userId: Scalars["String"]["output"];
};

export type User1on1ClassroomPlanToBeRedeemedGraphqlDto = {
  createdAt: Scalars["DateTimeISO"]["output"];
  createdPlanId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  oneOnOneDurationInWeeks?: Maybe<Scalars["Float"]["output"]>;
  oneOnOneMaxCancellations?: Maybe<Scalars["Float"]["output"]>;
  totalNumberOfLessons: Scalars["Float"]["output"];
  user: User1on1ClassroomPlanToBeRedeemedUserGraphqlDto;
};

export type User1on1ClassroomPlanToBeRedeemedUserGraphqlDto = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type UserActivePlansStatus = {
  hasActive1on1Plan: Scalars["Boolean"]["output"];
  hasActiveGroupPlan: Scalars["Boolean"]["output"];
};

export type UserActivityCounters = {
  noShowCount: Scalars["Int"]["output"];
  participatedProgressCheckCount: Scalars["Int"]["output"];
  participatedSpeakingClassCount: Scalars["Int"]["output"];
  receivedLessonFeedbackCount: Scalars["Int"]["output"];
  receivedProgressCheckFeedbackCount: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
};

/** Inclusive ranges on the user lesson counters. Leave min or max empty to keep only values above or below the other bound. */
export type UserActivityRangesInput = {
  noShowCount?: InputMaybe<IntRangeInput>;
  participatedProgressCheckCount?: InputMaybe<IntRangeInput>;
  participatedSpeakingClassCount?: InputMaybe<IntRangeInput>;
  receivedLessonFeedbackCount?: InputMaybe<IntRangeInput>;
  receivedProgressCheckFeedbackCount?: InputMaybe<IntRangeInput>;
};

export type UserClassRoomFeedback = {
  differentSpeakingLevelSuggested?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes: Scalars["String"]["output"];
  participation: Scalars["Int"]["output"];
  targetLanguage: Scalars["Int"]["output"];
  teacherId: Scalars["String"]["output"];
};

export type UserClassRoomHistoryItem = {
  attendedParticipantsCount: Scalars["Int"]["output"];
  capacity: Scalars["Int"]["output"];
  classRoomId: Scalars["String"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  classRoomType: ClassRoomType;
  endUtc: Scalars["String"]["output"];
  feedbackCount: Scalars["Int"]["output"];
  giftedByPromo: Scalars["Boolean"]["output"];
  is1on1: Scalars["Boolean"]["output"];
  isProgressCheck: Scalars["Boolean"]["output"];
  noShowParticipantsCount: Scalars["Int"]["output"];
  participantsCount: Scalars["Int"]["output"];
  progressCheckResult?: Maybe<UserClassRoomProgressCheckResult>;
  promoBonus?: Maybe<UserClassRoomPromoBonus>;
  speakingLevel: SpeakingClassLevel;
  startUtc: Scalars["String"]["output"];
  teacherEmail?: Maybe<Scalars["String"]["output"]>;
  teacherFamilyName?: Maybe<Scalars["String"]["output"]>;
  teacherGivenName?: Maybe<Scalars["String"]["output"]>;
  teacherId: Scalars["String"]["output"];
  topicName?: Maybe<Scalars["String"]["output"]>;
  userFeedback?: Maybe<UserClassRoomFeedback>;
  userGroupId: Scalars["String"]["output"];
  userGroupName?: Maybe<Scalars["String"]["output"]>;
  userNoShow: Scalars["Boolean"]["output"];
  userReview?: Maybe<UserClassRoomReview>;
};

export type UserClassRoomPlan = {
  bonuses?: Maybe<Array<UserClassRoomPlanBonus>>;
  endedAtWeekUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lessonsPerWeek: Scalars["Float"]["output"];
  mergeHistory?: Maybe<Array<PlanMergeHistoryEntry>>;
  numberOfSlotIncluded: Scalars["Float"]["output"];
  planToRecoverId?: Maybe<Scalars["String"]["output"]>;
  startedAtWeekUtc: Scalars["String"]["output"];
  unlimitedLessonsPerWeekEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  unlimitedLessonsPerWeekTotalLessons?: Maybe<Scalars["Float"]["output"]>;
  userId: Scalars["String"]["output"];
  warrantyConfig?: Maybe<UserClassRoomPlanWarrantyConfigDto>;
};

export type UserClassRoomPlanBonus = {
  activeFrom?: Maybe<Scalars["String"]["output"]>;
  activeTo?: Maybe<Scalars["String"]["output"]>;
  extraLessons?: Maybe<Scalars["Int"]["output"]>;
  extraWeeks?: Maybe<Scalars["Int"]["output"]>;
  lessonsCountedPerWeek?: Maybe<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

export type UserClassRoomPlanWarrantyConfigDto = {
  enabled: Scalars["Boolean"]["output"];
  minAttendedLessons?: Maybe<Scalars["Int"]["output"]>;
};

export type UserClassRoomPlanWarrantyConfigInputDto = {
  enabled: Scalars["Boolean"]["input"];
  minAttendedLessons?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserClassRoomProgressCheckResult = {
  accuracy: Scalars["Int"]["output"];
  comprehension: Scalars["Int"]["output"];
  fluency: Scalars["Int"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes: Scalars["String"]["output"];
  passed: Scalars["Boolean"]["output"];
  recommendation: Array<ProgressCheckRecommendation>;
  teacherId: Scalars["String"]["output"];
  toLevel?: Maybe<Scalars["String"]["output"]>;
  vocabularyRange: Scalars["Int"]["output"];
};

export type UserClassRoomPromoBonus = {
  activeFromUtc?: Maybe<Scalars["String"]["output"]>;
  activeToUtc?: Maybe<Scalars["String"]["output"]>;
  lessonsCountedPerWeek?: Maybe<Scalars["Int"]["output"]>;
  planId: Scalars["String"]["output"];
  promoIds: Array<Scalars["String"]["output"]>;
  type: PromoBonusType;
};

export type UserClassRoomReview = {
  generalLessonScore: Scalars["Float"]["output"];
  reviewNotes: Scalars["String"]["output"];
  reviewedAtUtc: Scalars["String"]["output"];
  teacherClearanceScore: Scalars["Float"]["output"];
  teacherComfortableScore: Scalars["Float"]["output"];
  teacherInvolvementScore: Scalars["Float"]["output"];
  topicDifficultyScore: Scalars["Float"]["output"];
  topicUsefulnessScore: Scalars["Float"]["output"];
};

export type UserGroup = {
  availability?: Maybe<Array<UserGroupAvailability>>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  onboardingLiveBookingWindowDays: Scalars["Int"]["output"];
  onboardingLiveRequired: Scalars["Boolean"]["output"];
  slug: Scalars["String"]["output"];
  thinkificBundleId?: Maybe<Scalars["Int"]["output"]>;
};

export type UserGroupAvailability = {
  timeIntervalTimezone: Scalars["String"]["output"];
  timeIntervals: Array<TimeInterval>;
  weekDay: WeekDayEnum;
};

export type UserGroupAvailabilityInput = {
  timeIntervalTimezone: Scalars["String"]["input"];
  timeIntervals: Array<TimeIntervalInput>;
  weekDay: WeekDayEnum;
};

export type UserLessonFeedbackDto = {
  classRoomEndDateUtc: Scalars["String"]["output"];
  classRoomStartDateUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isOneOnOne: Scalars["Boolean"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes: Scalars["String"]["output"];
  participation: Scalars["Int"]["output"];
  targetLanguage: Scalars["Int"]["output"];
  teacher: ClassRoomTeacher;
  teacherId: Scalars["String"]["output"];
};

export type UserLessonFeedbackNote = {
  classRoomStartDateUtc: Scalars["String"]["output"];
  classRoomTopicName: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
};

export type UserLessonFeedbackReport = {
  avgParticipationScore: Scalars["Float"]["output"];
  avgTargetLanguageScore: Scalars["Float"]["output"];
  hasAtLeastOneFeedback: Scalars["Boolean"]["output"];
  notes: Array<UserLessonFeedbackNote>;
  userFamilyName: Scalars["String"]["output"];
  userGivenName: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type UserLessonsInfoGraphqlDto = {
  lessonsInfo: Array<LessonInfoGraphqlDto>;
};

export enum UserListSortDirection {
  Asc = "Asc",
  Desc = "Desc",
}

/** The field the users list can be sorted by */
export enum UserListSortField {
  CreatedAt = "CreatedAt",
  Email = "Email",
  NoShowCount = "NoShowCount",
  ParticipatedProgressCheckCount = "ParticipatedProgressCheckCount",
  ParticipatedSpeakingClassCount = "ParticipatedSpeakingClassCount",
  ReceivedLessonFeedbackCount = "ReceivedLessonFeedbackCount",
  ReceivedProgressCheckFeedbackCount = "ReceivedProgressCheckFeedbackCount",
  SpeakingLevel = "SpeakingLevel",
}

export type UserStatistics = {
  /** Users who opened the user area in the last 7 days */
  loggedInLast7DaysCount: Scalars["Int"]["output"];
  /** Users who opened the user area in the last 30 days */
  loggedInLast30DaysCount: Scalars["Int"]["output"];
  /** Only the days with at least one new user */
  newUsersPerDay: Array<NewUsersOnDay>;
};

export enum WeekDayEnum {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type WeekSlot = {
  dayOfWeek: Scalars["Int"]["output"];
  endTime: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export type WeekSlotInput = {
  dayOfWeek: Scalars["Int"]["input"];
  endTime: Scalars["String"]["input"];
  startTime: Scalars["String"]["input"];
};

export type WeekWithPlan = {
  planId: Scalars["String"]["output"];
  week: FrozenWeekDto;
};

export enum WithdrawalNotificationRecipient {
  Closer = "Closer",
  FallbackTeamLeader = "FallbackTeamLeader",
  StudentsTeam = "StudentsTeam",
}

export enum WithdrawalOutcome {
  Avoided = "Avoided",
  Confirmed = "Confirmed",
}

export enum WithdrawalPlanType {
  Group = "Group",
  OneOnOne = "OneOnOne",
}

export enum WithdrawalRequestStatus {
  Cancelled = "Cancelled",
  PartiallyRefunded = "PartiallyRefunded",
  Pending = "Pending",
  Refunded = "Refunded",
  ToRefund = "ToRefund",
  WithdrawalAvoided = "WithdrawalAvoided",
}

export type WorkedHour = {
  endDateUtc: Scalars["String"]["output"];
  hourlyWageInCents: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  startDateUtc: Scalars["String"]["output"];
};

export type WorkedHoursByMonthItem = {
  endOfMonthDate: Scalars["String"]["output"];
  startOfMonthDate: Scalars["String"]["output"];
  totalTaxableAmountInCents: Scalars["Float"]["output"];
};

export type SpeakingClassServiceAgGridQueryQueryVariables = Exact<{
  params: AgGridParamsInput;
}>;

export type SpeakingClassServiceAgGridQueryQuery = {
  speakingClassServiceAgGridQuery: { hasNext: boolean; data: any };
};

export type GetAvailableTeacherSlotsQueryVariables = Exact<{
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
}>;

export type GetAvailableTeacherSlotsQuery = {
  getAvailableTeacherSlots: Array<{
    startUtc: string;
    endUtc: string;
    slotTimezone: string;
    teacherIds: Array<string>;
  }>;
};

export type GetBookedClassRoomsQueryVariables = Exact<{
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
}>;

export type GetBookedClassRoomsQuery = {
  getBookedClassRooms: Array<{
    classRoomId: string;
    startUtc: string;
    endUtc: string;
    teacherId: string;
    classRoomTimezone: string;
    userGroupId: string;
    is1on1?: boolean | null;
  }>;
};

export type GetClassRoomSelectionDetailQueryVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type GetClassRoomSelectionDetailQuery = {
  getClassRoomSelectionDetail?: {
    classRoomId: string;
    strategyName?: string | null;
    candidates: Array<{
      teacherId: string;
      reviewAvg?: number | null;
      reviewCount?: number | null;
      wasSelected: boolean;
      weeklyCap?: {
        tier: TeacherTier;
        maxPercentOfWeeklyAvailability: number;
        offeredSlots: number;
        assignedClassRooms: number;
        maxAssignableClassRooms: number;
        hasBeenReached: boolean;
      } | null;
    }>;
  } | null;
};

export type GetClassRoomSelectionHistoryQueryVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type GetClassRoomSelectionHistoryQuery = {
  getClassRoomSelectionHistory: Array<{
    strategyName: string;
    selectedTeacherId: string;
    assignedAt: string;
    candidates: Array<{
      teacherId: string;
      reviewAvg?: number | null;
      reviewCount?: number | null;
      wasSelected: boolean;
      weeklyCap?: {
        tier: TeacherTier;
        maxPercentOfWeeklyAvailability: number;
        offeredSlots: number;
        assignedClassRooms: number;
        maxAssignableClassRooms: number;
        hasBeenReached: boolean;
      } | null;
    }>;
  }>;
};

export type GetClassRoomsWhereTeacherWasCandidateQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  classRoomIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetClassRoomsWhereTeacherWasCandidateQuery = {
  getClassRoomsWhereTeacherWasCandidate: Array<string>;
};

export type BulkClassRoomCreationRequestFragment = {
  id: string;
  createdAt: any;
  updatedAt?: any | null;
  status: BulkClassRoomCreationRequestStatus;
  totalClassRoomsToCreate: number;
  teacher: { id: string; givenName: string; familyName: string };
  user: { id: string; givenName: string; familyName: string; authId: string };
} & { " $fragmentName"?: "BulkClassRoomCreationRequestFragment" };

export type TeacherSubstitutionResultFragment = {
  successfulSubstitutions: Array<{
    classRoomId: string;
    isOnboardingLive: boolean;
    startDateUtc: any;
    endDateUtc: any;
    originalTeacher: {
      id: string;
      email: string;
      givenName: string;
      familyName: string;
      lesson1on1: boolean;
    };
    newTeacher: {
      id: string;
      email: string;
      givenName: string;
      familyName: string;
      lesson1on1: boolean;
    };
  }>;
  failedSubstitutions: Array<{
    classRoomId: string;
    startDateUtc: any;
    endDateUtc: any;
    reason: string;
    teacher?: {
      id: string;
      email: string;
      givenName: string;
      familyName: string;
      lesson1on1: boolean;
    } | null;
  }>;
} & { " $fragmentName"?: "TeacherSubstitutionResultFragment" };

export type User1on1ClassroomPlanToBeRedeemedFragment = {
  id: string;
  createdAt: any;
  totalNumberOfLessons: number;
  createdPlanId?: string | null;
  user: { id: string; familyName: string; givenName: string; email: string };
} & { " $fragmentName"?: "User1on1ClassroomPlanToBeRedeemedFragment" };

export type CalculateBulkClassRoomCreationSlotsQueryVariables = Exact<{
  input: CalculateBulkClassRoomCreationSlotsInput;
}>;

export type CalculateBulkClassRoomCreationSlotsQuery = {
  calculateBulkClassRoomCreationSlots: Array<{
    startDateUtc: any;
    endDateUtc: any;
    teacherConflictingClass?: {
      id: string;
      type: ClassRoomType;
      is1on1: boolean;
      capacity: number;
      startedAtUtc: string;
      endedAtUtc: string;
      speakingLevel?: SpeakingClassLevel | null;
      userGroup: { id: string; name: string };
      participants: Array<{
        id: string;
        givenName: string;
        familyName: string;
      }>;
    } | null;
    userConflictingClass?: {
      id: string;
      is1on1: boolean;
      capacity: number;
      startedAtUtc: string;
      endedAtUtc: string;
      speakingLevel?: SpeakingClassLevel | null;
      userGroup: { id: string; name: string };
      participants: Array<{
        id: string;
        givenName: string;
        familyName: string;
      }>;
    } | null;
  }>;
};

export type CreateBulk1on1ClassRoomsMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
}>;

export type CreateBulk1on1ClassRoomsMutation = {
  createBulk1on1ClassRooms: { planId: string; requestId: string };
};

export type CreateBulkClassRoomCreationIntentMutationVariables = Exact<{
  input: CreateBulkClassRoomCreationIntentInput;
}>;

export type CreateBulkClassRoomCreationIntentMutation = {
  createBulkClassRoomCreationIntent: {
    id: string;
    createdAt: any;
    startDate?: any | null;
    numberOfWeeks?: number | null;
    maxClassRoomNumber?: number | null;
    user1on1ClassroomPlanToBeRedeemedId?: string | null;
    teacher?: { id: string; givenName: string; familyName: string } | null;
    user?: { id: string; givenName: string; familyName: string } | null;
    weekSlots?: Array<{
      dayOfWeek: number;
      startTime: string;
      endTime: string;
    }> | null;
  };
};

export type DeleteBulkClassRoomCreationIntentMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteBulkClassRoomCreationIntentMutation = {
  deleteBulkClassRoomCreationIntent: boolean;
};

export type GetActiveIntentsForStudentQueryVariables = Exact<{
  studentId: Scalars["String"]["input"];
}>;

export type GetActiveIntentsForStudentQuery = {
  getActiveIntentsForStudent: Array<{
    id: string;
    user1on1ClassroomPlanToBeRedeemedId?: string | null;
  }>;
};

export type BulkClassRoomCreationIntentFragment = {
  id: string;
  createdAt: any;
  startDate?: any | null;
  numberOfWeeks?: number | null;
  maxClassRoomNumber?: number | null;
  user1on1ClassroomPlanToBeRedeemedId?: string | null;
  teacher?: { id: string; givenName: string; familyName: string } | null;
  user?: { id: string; givenName: string; familyName: string } | null;
  weekSlots?: Array<{
    dayOfWeek: number;
    startTime: string;
    endTime: string;
  }> | null;
} & { " $fragmentName"?: "BulkClassRoomCreationIntentFragment" };

export type GetAllBulkClassRoomCreationIntentsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
}>;

export type GetAllBulkClassRoomCreationIntentsQuery = {
  getAllBulkClassRoomCreationIntents: Array<{
    " $fragmentRefs"?: {
      BulkClassRoomCreationIntentFragment: BulkClassRoomCreationIntentFragment;
    };
  }>;
};

export type GetAllBulkClassRoomCreationRequestsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllBulkClassRoomCreationRequestsQuery = {
  getAllBulkClassRoomCreationRequests: Array<{
    " $fragmentRefs"?: {
      BulkClassRoomCreationRequestFragment: BulkClassRoomCreationRequestFragment;
    };
  }>;
};

export type GetBulkClassRoomCreationIntentQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetBulkClassRoomCreationIntentQuery = {
  getBulkClassRoomCreationIntent: {
    id: string;
    createdAt: any;
    startDate?: any | null;
    numberOfWeeks?: number | null;
    maxClassRoomNumber?: number | null;
    user1on1ClassroomPlanToBeRedeemedId?: string | null;
    excludedSlots?: Array<string> | null;
    additionalSlots?: Array<{
      startDateUtc: string;
      endDateUtc: string;
    }> | null;
    teacher?: { id: string; givenName: string; familyName: string } | null;
    user?: { id: string; givenName: string; familyName: string } | null;
    weekSlots?: Array<{
      dayOfWeek: number;
      startTime: string;
      endTime: string;
    }> | null;
  };
};

export type GetBulkClassRoomCreationRequestQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetBulkClassRoomCreationRequestQuery = {
  getBulkClassRoomCreationRequest?: {
    " $fragmentRefs"?: {
      BulkClassRoomCreationRequestFragment: BulkClassRoomCreationRequestFragment;
    };
  } | null;
};

export type GetUser1on1ClassroomPlansToBeRedeemedQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUser1on1ClassroomPlansToBeRedeemedQuery = {
  getUser1on1ClassroomPlansToBeRedeemed: Array<{
    " $fragmentRefs"?: {
      User1on1ClassroomPlanToBeRedeemedFragment: User1on1ClassroomPlanToBeRedeemedFragment;
    };
  }>;
};

export type GetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdQueryVariables =
  Exact<{
    limit: Scalars["Int"]["input"];
    offset: Scalars["Int"]["input"];
  }>;

export type GetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdQuery = {
  getUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanId: Array<{
    " $fragmentRefs"?: {
      User1on1ClassroomPlanToBeRedeemedFragment: User1on1ClassroomPlanToBeRedeemedFragment;
    };
  }>;
};

export type Try1on1TeacherSubstitutionMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type Try1on1TeacherSubstitutionMutation = {
  try1on1TeacherSubstitution: {
    " $fragmentRefs"?: {
      TeacherSubstitutionResultFragment: TeacherSubstitutionResultFragment;
    };
  };
};

export type UpdateBulkClassRoomCreationIntentMutationVariables = Exact<{
  input: UpdateBulkClassRoomCreationIntentInput;
}>;

export type UpdateBulkClassRoomCreationIntentMutation = {
  updateBulkClassRoomCreationIntent: {
    id: string;
    createdAt: any;
    startDate?: any | null;
    numberOfWeeks?: number | null;
    maxClassRoomNumber?: number | null;
    user1on1ClassroomPlanToBeRedeemedId?: string | null;
    excludedSlots?: Array<string> | null;
    additionalSlots?: Array<{
      startDateUtc: string;
      endDateUtc: string;
    }> | null;
    teacher?: { id: string; givenName: string; familyName: string } | null;
    user?: { id: string; givenName: string; familyName: string } | null;
    weekSlots?: Array<{
      dayOfWeek: number;
      startTime: string;
      endTime: string;
    }> | null;
  };
};

export type ClassRoomListItemFragment = {
  id: string;
  startedAtUtc: string;
  endedAtUtc: string;
  type: ClassRoomType;
  speakingLevel: SpeakingClassLevel;
  participantsCount: number;
  capacity: number;
  completedFeedbacksCount: number;
  topic: { id: string; name: string };
  teacher: {
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    phone?: { countryCode: string; number: string } | null;
  };
} & { " $fragmentName"?: "ClassRoomListItemFragment" };

export type ClassRoomWithParticipantsFragment = {
  id: string;
  speakingLevel?: SpeakingClassLevel | null;
  startedAtUtc: string;
  endedAtUtc: string;
  capacity: number;
  topic?: { name: string } | null;
  participants: Array<{ id: string; givenName: string; familyName: string }>;
} & { " $fragmentName"?: "ClassRoomWithParticipantsFragment" };

export type ClassRoomWithoutParticipantFragment = {
  id: string;
  startedAtUtc: string;
  endedAtUtc: string;
  speakingLevel: SpeakingClassLevel;
  participantsCount: number;
  classRoomTimezone: string;
  type: ClassRoomType;
  is1on1?: boolean | null;
  userGroupId: string;
  topic: { name: string };
} & { " $fragmentName"?: "ClassRoomWithoutParticipantFragment" };

export type CompleteClassRoomFragment = {
  id: string;
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: string;
  endedAtUtc: string;
  capacity: number;
  conferenceUri: string;
  feedbackUrl: string;
  feedbackReportUrl: string;
  is1on1?: boolean | null;
  userGroupId: string;
  topic: { name: string };
  participants: Array<{
    id: string;
    givenName: string;
    familyName: string;
    email: string;
  }>;
  teacher: { email: string; id: string; familyName: string; givenName: string };
} & { " $fragmentName"?: "CompleteClassRoomFragment" };

export type GetMinUsedTopicInLevelAmongParticipantsQueryVariables = Exact<{
  participantIds:
    | Array<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
  speakingLevel: SpeakingClassLevel;
}>;

export type GetMinUsedTopicInLevelAmongParticipantsQuery = {
  getMinUsedTopicsInLevelAmongParticipants: Array<{
    " $fragmentRefs"?: { TopicItemFragment: TopicItemFragment };
  }>;
};

export type CreateClassRoomMutationVariables = Exact<{
  capacity: Scalars["Int"]["input"];
  classRoomType: ClassRoomType;
  participantIds:
    | Array<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
  speakingLevel: SpeakingClassLevel;
  startUtc: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
  isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateClassRoomMutation = { createClassRoom: { id: string } };

export type AddParticipantsToClassByEmailMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
  emails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  skipLevelCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AddParticipantsToClassByEmailMutation = {
  addParticipantsToClassByEmail: {
    " $fragmentRefs"?: {
      ClassRoomWithParticipantsFragment: ClassRoomWithParticipantsFragment;
    };
  };
};

export type AdminGetClassRoomByIdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetClassRoomByIdQuery = {
  adminGetClassRoomById: {
    " $fragmentRefs"?: { CompleteClassRoomFragment: CompleteClassRoomFragment };
  };
};

export type ListClassRoomsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  nextToken?: InputMaybe<Scalars["String"]["input"]>;
  prevToken?: InputMaybe<Scalars["String"]["input"]>;
  dateRange?: InputMaybe<ListClassRoomDateInput>;
}>;

export type ListClassRoomsQuery = {
  listClassRooms: {
    hasNextPage: boolean;
    hasPrevPage: boolean;
    nextPageToken?: string | null;
    prevPageToken?: string | null;
    classRooms: Array<{
      " $fragmentRefs"?: {
        ClassRoomListItemFragment: ClassRoomListItemFragment;
      };
    }>;
  };
};

export type DeleteClassRoomMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type DeleteClassRoomMutation = { deleteClassRoom: boolean };

export type RemoveParticipantFromClassRoomMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}>;

export type RemoveParticipantFromClassRoomMutation = {
  removeParticipantFromClassRoom: {
    classRoomDeleted: boolean;
    classRoom: {
      " $fragmentRefs"?: {
        ClassRoomWithParticipantsFragment: ClassRoomWithParticipantsFragment;
      };
    };
  };
};

export type SwapTeacherMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  doNotMakeOldTeacherAvailableAgain: Scalars["Boolean"]["input"];
}>;

export type SwapTeacherMutation = { swapTeacher: boolean };

export type FranchiseeItemFragment = {
  id: string;
  email: string;
  familyName: string;
  givenName: string;
  userGroupIds: Array<string>;
  authId: string;
  lesson1on1?: boolean | null;
  internalTeacher?: boolean | null;
  roles: Array<TeacherRole>;
  tags: Array<TeacherTag>;
  createdAt?: string | null;
  phoneNumber?: { countryCode: string; number: string } | null;
} & { " $fragmentName"?: "FranchiseeItemFragment" };

export type ClassRoomTeacherFragmentFragment = {
  id: string;
  email: string;
  givenName: string;
  familyName: string;
  phone?: { countryCode: string; number: string } | null;
} & { " $fragmentName"?: "ClassRoomTeacherFragmentFragment" };

export type GetTeacherCreatedAtQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetTeacherCreatedAtQuery = {
  getFranchiseeById: { id: string; createdAt?: string | null };
};

export type GetTeacherAssignmentCapOverviewQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  upcomingWeeks: Scalars["Int"]["input"];
}>;

export type GetTeacherAssignmentCapOverviewQuery = {
  getTeacherAssignmentCapOverview: {
    finalScore: number;
    tier: TeacherTier;
    maxPercentOfWeeklyAvailability: number;
    weeks: Array<{
      weekStartUtc: string;
      weekEndUtc: string;
      offeredSlots: number;
      assignedClassRooms: number;
      maxAssignableClassRooms: number;
      hasBeenReached: boolean;
    }>;
  };
};

export type GetTeacherWeekAssignmentCapQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  weekDate: Scalars["String"]["input"];
}>;

export type GetTeacherWeekAssignmentCapQuery = {
  getTeacherWeekAssignmentCap: {
    weekStartUtc: string;
    weekEndUtc: string;
    offeredSlots: number;
    assignedClassRooms: number;
    weeklyCapWithCurrentTier?: {
      tier: TeacherTier;
      maxPercentOfWeeklyAvailability: number;
      maxAssignableClassRooms: number;
      hasBeenReached: boolean;
    } | null;
  };
};

export type AvailabilitySlotFragmentFragment = {
  slotId: string;
  startDateUtc: string;
  endDateUtc: string;
  slotTimezone: string;
} & { " $fragmentName"?: "AvailabilitySlotFragmentFragment" };

export type RemoveAvailabilitySlotMutationVariables = Exact<{
  slotId: Scalars["String"]["input"];
}>;

export type RemoveAvailabilitySlotMutation = {
  removeAvailabilitySlot: boolean;
};

export type GetAvailabilityByTeacherForWeekQueryVariables = Exact<{
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
}>;

export type GetAvailabilityByTeacherForWeekQuery = {
  getAvailabilityByTeacherForWeek: Array<{
    " $fragmentRefs"?: {
      AvailabilitySlotFragmentFragment: AvailabilitySlotFragmentFragment;
    };
  }>;
};

export type GetTeacherClassRoomsQueryVariables = Exact<{
  timezone: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
}>;

export type GetTeacherClassRoomsQuery = {
  getTeacherClassRooms: Array<{
    " $fragmentRefs"?: {
      ClassRoomWithoutParticipantFragment: ClassRoomWithoutParticipantFragment;
    };
  }>;
};

export type LeaveTeacherCoordinatorReviewMutationVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  fluencyScore: Scalars["Int"]["input"];
  presenceScore: Scalars["Int"]["input"];
  clarityScore: Scalars["Int"]["input"];
}>;

export type LeaveTeacherCoordinatorReviewMutation = {
  leaveTeacherCoordinatorReview: {
    id: string;
    teacherId: string;
    reviewedAtUtc: string;
  };
};

export type GetNewTeacherIdsQueryVariables = Exact<{
  checks: Array<NewTeacherCheckInput> | NewTeacherCheckInput;
}>;

export type GetNewTeacherIdsQuery = { getNewTeacherIds: Array<string> };

export type GetTeacherCoordinatorReviewHistoryQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
}>;

export type GetTeacherCoordinatorReviewHistoryQuery = {
  getTeacherCoordinatorReviewHistory: Array<{
    id: string;
    teacherId: string;
    reviewedAtUtc: string;
    scores: {
      fluencyScore: number;
      presenceScore: number;
      clarityScore: number;
    };
  }>;
};

export type GetTeacherCoordinatorReviewsQueryVariables = Exact<{
  teacherIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetTeacherCoordinatorReviewsQuery = {
  getTeacherCoordinatorReviews: Array<{
    id: string;
    teacherId: string;
    reviewedAtUtc: string;
  }>;
};

export type GetTeacherScoreQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
}>;

export type GetTeacherScoreQuery = {
  getTeacherScore: {
    studentBayesianAvg: number;
    coordinatorScore?: number | null;
    finalScore: number;
  };
};

export type GetTeacherScoresQueryVariables = Exact<{
  teacherIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetTeacherScoresQuery = {
  getTeacherScores: Array<{
    teacherId: string;
    studentBayesianAvg: number;
    coordinatorScore?: number | null;
    finalScore: number;
  }>;
};

export type GetTeacherStudentReviewCountsQueryVariables = Exact<{
  teacherIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetTeacherStudentReviewCountsQuery = {
  getTeacherStudentReviewCounts: Array<{
    teacherId: string;
    totalReviews: number;
  }>;
};

export type GetTeacherStudentReviewsQueryVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTeacherStudentReviewsQuery = {
  getTeacherStudentReviews: {
    simulatedStudentScore: number;
    students: Array<{
      userId: string;
      decayedAvg: number;
      reviews: Array<{
        id: string;
        reviewedAtUtc: string;
        clearanceScore: number;
        involvementScore: number;
        comfortableScore: number;
        teacherAvg: number;
        decayWeight: number;
      }>;
    }>;
  };
};

export type UpdateLatestTeacherCoordinatorReviewMutationVariables = Exact<{
  teacherId: Scalars["String"]["input"];
  fluencyScore: Scalars["Int"]["input"];
  presenceScore: Scalars["Int"]["input"];
  clarityScore: Scalars["Int"]["input"];
}>;

export type UpdateLatestTeacherCoordinatorReviewMutation = {
  updateLatestTeacherCoordinatorReview: {
    id: string;
    teacherId: string;
    reviewedAtUtc: string;
    scores: {
      fluencyScore: number;
      presenceScore: number;
      clarityScore: number;
    };
  };
};

export type GetTeachersWithMissingFeedbackQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTeachersWithMissingFeedbackQuery = {
  getTeachersWithMissingFeedback: Array<{
    teacherId: string;
    classRoomsWithMissingFeedback: Array<{
      classRoom: {
        id: string;
        type: ClassRoomType;
        startedAtUtc: string;
        speakingLevel?: SpeakingClassLevel | null;
        is1on1?: boolean | null;
        feedbackUri: string;
        participantsCount: number;
        topic?: { id: string; name: string } | null;
        userGroup: { id: string; name: string };
      };
      participantsWithoutFeedback: Array<{
        id: string;
        givenName: string;
        familyName: string;
      }>;
    }>;
  }>;
};

export type GetAllFranchiseesQueryVariables = Exact<{
  isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
  isInternal?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetAllFranchiseesQuery = {
  getAllFranchisees: Array<{
    " $fragmentRefs"?: { FranchiseeItemFragment: FranchiseeItemFragment };
  }>;
};

export type GetAvailableTeachersInHourQueryVariables = Exact<{
  startUtc: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
}>;

export type GetAvailableTeachersInHourQuery = {
  getAvailableTeachersInHour: Array<{
    " $fragmentRefs"?: {
      ClassRoomTeacherFragmentFragment: ClassRoomTeacherFragmentFragment;
    };
  }>;
};

export type CreateFranchiseeMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  familyName: Scalars["String"]["input"];
  givenName: Scalars["String"]["input"];
  phoneNumber: PhoneNumberInput;
  userGroupIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
  roles?: InputMaybe<Array<TeacherRole> | TeacherRole>;
  tags?: InputMaybe<Array<TeacherTag> | TeacherTag>;
}>;

export type CreateFranchiseeMutation = { createFranchisee: { id: string } };

export type DeleteTeacherMutationVariables = Exact<{
  teacherId: Scalars["String"]["input"];
}>;

export type DeleteTeacherMutation = { deleteTeacher: boolean };

export type GetFranchiseeByIdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetFranchiseeByIdQuery = {
  getFranchiseeById: {
    id: string;
    email: string;
    familyName: string;
    givenName: string;
    userGroupIds: Array<string>;
    authId: string;
    lesson1on1?: boolean | null;
    internalTeacher?: boolean | null;
    roles: Array<TeacherRole>;
    tags: Array<TeacherTag>;
    phoneNumber?: { countryCode: string; number: string } | null;
  };
};

export type UpdateTeacherMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  userGroupIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  roles?: InputMaybe<Array<TeacherRole> | TeacherRole>;
  tags?: InputMaybe<Array<TeacherTag> | TeacherTag>;
}>;

export type UpdateTeacherMutation = { updateTeacher: { id: string } };

export type OnboardingLiveSlotPlanItemFragment = {
  slotId: string;
  status: OnboardingLiveSlotPlanStatus;
  teacherId?: string | null;
  forcedRoster: boolean;
  reassignment?: {
    classRoomId: string;
    fromTeacherId: string;
    toTeacherId: string;
  } | null;
  issues: Array<{
    code: OnboardingLivePlanIssueCode;
    severity: OnboardingLivePlanIssueSeverity;
    relatedTeacherId?: string | null;
    relatedClassRoom?: {
      id: string;
      type: ClassRoomType;
      is1on1: boolean;
      startUtc: string;
      endUtc: string;
      userGroupId: string;
      teacherId: string;
    } | null;
  }>;
} & { " $fragmentName"?: "OnboardingLiveSlotPlanItemFragment" };

export type OnboardingLiveCreationIntentItemFragment = {
  id: string;
  userGroupId: string;
  status: OnboardingLiveCreationIntentStatus;
  createdByEmail?: string | null;
  createdAtUtc: string;
  updatedAtUtc: string;
  confirmedByEmail?: string | null;
  confirmedAtUtc?: string | null;
  cancelledByEmail?: string | null;
  cancelledAtUtc?: string | null;
  completedAtUtc?: string | null;
  lastCheckedAtUtc?: string | null;
  slots: Array<{
    id: string;
    startUtc: string;
    endUtc: string;
    requestedTeacherId?: string | null;
    creationStatus?: OnboardingLiveSlotCreationStatus | null;
    onboardingLiveId?: string | null;
    creationFailureReason?: string | null;
    lastCheckPlan?: {
      " $fragmentRefs"?: {
        OnboardingLiveSlotPlanItemFragment: OnboardingLiveSlotPlanItemFragment;
      };
    } | null;
    creationPlan?: {
      " $fragmentRefs"?: {
        OnboardingLiveSlotPlanItemFragment: OnboardingLiveSlotPlanItemFragment;
      };
    } | null;
  }>;
} & { " $fragmentName"?: "OnboardingLiveCreationIntentItemFragment" };

export type OnboardingLiveItemFragment = {
  id: string;
  startUtc: string;
  endUtc: string;
  userGroupId: string;
  teacherId: string;
  participantsCount: number;
  capacity: number;
  meetingUri: string;
  pdfUrl: string;
  creationIntentId?: string | null;
  hasStarted: boolean;
  hasEnded: boolean;
  feedback?: {
    participantsCount: number;
    notes?: string | null;
    issues?: string | null;
    createdAtUtc: string;
    updatedAtUtc?: string | null;
  } | null;
  participants: Array<{
    id: string;
    givenName: string;
    familyName: string;
    speakingLevel: SpeakingClassLevel;
  }>;
} & { " $fragmentName"?: "OnboardingLiveItemFragment" };

export type GetAllOnboardingLivePdfsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllOnboardingLivePdfsQuery = {
  getAllOnboardingLivePdfs: Array<{ userGroupId: string; pdfUrl: string }>;
};

export type UpsertOnboardingLivePdfMutationVariables = Exact<{
  userGroupId: Scalars["String"]["input"];
  pdfUrl: Scalars["String"]["input"];
}>;

export type UpsertOnboardingLivePdfMutation = {
  upsertOnboardingLivePdf: { userGroupId: string; pdfUrl: string };
};

export type DeleteOnboardingLivePdfMutationVariables = Exact<{
  userGroupId: Scalars["String"]["input"];
}>;

export type DeleteOnboardingLivePdfMutation = {
  deleteOnboardingLivePdf: boolean;
};

export type GetOnboardingLiveStatisticsRecordsQueryVariables = Exact<{
  fromUtc: Scalars["String"]["input"];
  toUtc: Scalars["String"]["input"];
}>;

export type GetOnboardingLiveStatisticsRecordsQuery = {
  getOnboardingLiveStatisticsRecords: {
    lives: Array<{
      id: string;
      startUtc: string;
      teacherId: string;
      participantsCount: number;
      hasEnded: boolean;
      feedback?: { participantsCount: number } | null;
    }>;
    deletedLives: Array<{ id: string; participantsCount: number }>;
    cancellations: Array<{
      onboardingLiveId: string;
      cancelledBy: OnboardingLiveCancelledBy;
    }>;
    conductorChanges: Array<{
      onboardingLiveId: string;
      fromTeacherId: string;
    }>;
  };
};

export type GetOnboardingLiveFunnelStatisticsQueryVariables = Exact<{
  fromUtc: Scalars["String"]["input"];
  toUtc: Scalars["String"]["input"];
}>;

export type GetOnboardingLiveFunnelStatisticsQuery = {
  getOnboardingLiveFunnelStatistics: {
    usersWithOnboardingLiveToBeDone: number;
    usersWaitingForMoreThanAWeek: number;
    usersWhoCompletedOnboardingLive: number;
    averageDaysToCompleteOnboardingLive?: number | null;
    medianDaysToCompleteOnboardingLive?: number | null;
  };
};

export type CreateOnboardingLiveCreationIntentMutationVariables = Exact<{
  userGroupId: Scalars["String"]["input"];
}>;

export type CreateOnboardingLiveCreationIntentMutation = {
  createOnboardingLiveCreationIntent: { id: string };
};

export type GetOnboardingLiveByIdQueryVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
}>;

export type GetOnboardingLiveByIdQuery = {
  getOnboardingLiveById: {
    " $fragmentRefs"?: {
      OnboardingLiveItemFragment: OnboardingLiveItemFragment;
    };
  };
};

export type CheckOnboardingLiveConductorChangeMutationVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CheckOnboardingLiveConductorChangeMutation = {
  checkOnboardingLiveConductorChange: {
    " $fragmentRefs"?: {
      OnboardingLiveSlotPlanItemFragment: OnboardingLiveSlotPlanItemFragment;
    };
  };
};

export type ChangeOnboardingLiveConductorMutationVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
  makeReplacedConductorAvailableAgain: Scalars["Boolean"]["input"];
}>;

export type ChangeOnboardingLiveConductorMutation = {
  changeOnboardingLiveConductor: {
    plan: {
      " $fragmentRefs"?: {
        OnboardingLiveSlotPlanItemFragment: OnboardingLiveSlotPlanItemFragment;
      };
    };
    onboardingLive?: { id: string } | null;
  };
};

export type DeleteOnboardingLiveMutationVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
  makeConductorAvailableAgain: Scalars["Boolean"]["input"];
}>;

export type DeleteOnboardingLiveMutation = { deleteOnboardingLive: boolean };

export type AddParticipantsToOnboardingLiveMutationVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
  userEmails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type AddParticipantsToOnboardingLiveMutation = {
  addParticipantsToOnboardingLive: { id: string };
};

export type RemoveParticipantFromOnboardingLiveMutationVariables = Exact<{
  onboardingLiveId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}>;

export type RemoveParticipantFromOnboardingLiveMutation = {
  removeParticipantFromOnboardingLive: { id: string };
};

export type GetOnboardingLiveCreationIntentQueryVariables = Exact<{
  intentId: Scalars["String"]["input"];
}>;

export type GetOnboardingLiveCreationIntentQuery = {
  getOnboardingLiveCreationIntent: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type ChangeOnboardingLiveCreationIntentUserGroupMutationVariables =
  Exact<{
    intentId: Scalars["String"]["input"];
    userGroupId: Scalars["String"]["input"];
  }>;

export type ChangeOnboardingLiveCreationIntentUserGroupMutation = {
  changeOnboardingLiveCreationIntentUserGroup: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type AddOnboardingLiveCreationIntentSlotsMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
  slots: Array<OnboardingLiveSlotInput> | OnboardingLiveSlotInput;
}>;

export type AddOnboardingLiveCreationIntentSlotsMutation = {
  addOnboardingLiveCreationIntentSlots: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type UpdateOnboardingLiveCreationIntentSlotMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
  slotId: Scalars["String"]["input"];
  slot: OnboardingLiveSlotInput;
}>;

export type UpdateOnboardingLiveCreationIntentSlotMutation = {
  updateOnboardingLiveCreationIntentSlot: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type RemoveOnboardingLiveCreationIntentSlotsMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
  slotIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type RemoveOnboardingLiveCreationIntentSlotsMutation = {
  removeOnboardingLiveCreationIntentSlots: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type CheckOnboardingLiveCreationIntentMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
}>;

export type CheckOnboardingLiveCreationIntentMutation = {
  checkOnboardingLiveCreationIntent: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type ConfirmOnboardingLiveCreationIntentMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
}>;

export type ConfirmOnboardingLiveCreationIntentMutation = {
  confirmOnboardingLiveCreationIntent: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type CancelOnboardingLiveCreationIntentMutationVariables = Exact<{
  intentId: Scalars["String"]["input"];
}>;

export type CancelOnboardingLiveCreationIntentMutation = {
  cancelOnboardingLiveCreationIntent: {
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  };
};

export type GetOnboardingLiveCreationIntentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOnboardingLiveCreationIntentsQuery = {
  getOnboardingLiveCreationIntents: Array<{
    " $fragmentRefs"?: {
      OnboardingLiveCreationIntentItemFragment: OnboardingLiveCreationIntentItemFragment;
    };
  }>;
};

export type GetOnboardingLivesQueryVariables = Exact<{
  period: OnboardingLiveListPeriod;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOnboardingLivesQuery = {
  getOnboardingLives: Array<{
    " $fragmentRefs"?: {
      OnboardingLiveItemFragment: OnboardingLiveItemFragment;
    };
  }>;
};

export type OneOnOneAssignmentPdfFragment = {
  pdfUrl: string;
  userGroupId: string;
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  assignmentNumber: number;
  businessEnglishObjective?: BusinessEnglishObjective | null;
  userGroup: { slug: string; id: string; name: string };
} & { " $fragmentName"?: "OneOnOneAssignmentPdfFragment" };

export type GetAllOneOnOneAssignmentPdfsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllOneOnOneAssignmentPdfsQuery = {
  getAllOneOnOneAssignmentPdfs: Array<{
    " $fragmentRefs"?: {
      OneOnOneAssignmentPdfFragment: OneOnOneAssignmentPdfFragment;
    };
  }>;
};

export type CreateOneOnOneAssignmentPdfMutationVariables = Exact<{
  assignmentNumber: Scalars["Int"]["input"];
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
}>;

export type CreateOneOnOneAssignmentPdfMutation = {
  createOneOnOneAssignmentPdf: {
    assignmentNumber: number;
    level: SpeakingClassLevel;
    oneOnOneLessonType: OneOnOneLessonType;
    pdfUrl: string;
    userGroupId: string;
    businessEnglishObjective?: BusinessEnglishObjective | null;
    userGroup: { id: string; name: string };
  };
};

export type DeleteOneOnOneAssignmentPdfMutationVariables = Exact<{
  assignmentNumber: Scalars["Int"]["input"];
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  userGroupId: Scalars["String"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
}>;

export type DeleteOneOnOneAssignmentPdfMutation = {
  deleteOneOnOneAssignmentPdf: boolean;
};

export type UpsertOneOnOneAssignmentPdfMutationVariables = Exact<{
  assignmentNumber: Scalars["Int"]["input"];
  level: SpeakingClassLevel;
  oneOnOneLessonType: OneOnOneLessonType;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
}>;

export type UpsertOneOnOneAssignmentPdfMutation = {
  upsertOneOnOneAssignmentPdf: boolean;
};

export type GetOneOnOnePlanPurchasesQueryVariables = Exact<{
  onboardingFormCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetOneOnOnePlanPurchasesQuery = {
  getOneOnOnePlanPurchases: Array<{
    orderId?: string | null;
    purchasedAt: any;
    userEmail: string;
    onboardingFormCompleted: boolean;
    hasActiveGroupPlan: boolean;
    lastGroupPlanEndDate?: any | null;
  }>;
};

export type ProgressCheckPdfFragment = {
  pdfUrl: string;
  userGroupId: string;
  level: SpeakingClassLevel;
  userGroup: { slug: string; id: string; name: string };
} & { " $fragmentName"?: "ProgressCheckPdfFragment" };

export type GetAllProgressCheckPdfsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllProgressCheckPdfsQuery = {
  getAllProgressCheckPdfs: Array<{
    " $fragmentRefs"?: { ProgressCheckPdfFragment: ProgressCheckPdfFragment };
  }>;
};

export type CreateProgressCheckPdfMutationVariables = Exact<{
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
}>;

export type CreateProgressCheckPdfMutation = {
  createProgressCheckPdf: {
    level: SpeakingClassLevel;
    pdfUrl: string;
    userGroupId: string;
    userGroup: { id: string; name: string };
  };
};

export type UpsertProgressCheckPdfMutationVariables = Exact<{
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
}>;

export type UpsertProgressCheckPdfMutation = {
  upsertProgressCheckPdf: boolean;
};

export type TopicItemFragment = {
  id: string;
  name: string;
  level: SpeakingClassLevel;
  pdfUrl: string;
  userGroupIds: Array<string>;
  userGroups: Array<{ id: string; name: string }>;
} & { " $fragmentName"?: "TopicItemFragment" };

export type GetAllTopicsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllTopicsQuery = {
  getAllTopics: Array<{
    " $fragmentRefs"?: { TopicItemFragment: TopicItemFragment };
  }>;
};

export type CreateTopicMutationVariables = Exact<{
  nameIt: Scalars["String"]["input"];
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type CreateTopicMutation = {
  createTopic: {
    id: string;
    name: string;
    level: SpeakingClassLevel;
    userGroupIds: Array<string>;
    userGroups: Array<{ id: string; name: string }>;
  };
};

export type EditTopicMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  nameIt?: InputMaybe<Scalars["String"]["input"]>;
  pdfUrl?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EditTopicMutation = {
  editTopic: { " $fragmentRefs"?: { TopicItemFragment: TopicItemFragment } };
};

export type LogicallyDeleteTopicMutationVariables = Exact<{
  topicId: Scalars["String"]["input"];
}>;

export type LogicallyDeleteTopicMutation = { logicallyDeleteTopic: boolean };

export type GetTopicByIdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetTopicByIdQuery = {
  getTopicById: { " $fragmentRefs"?: { TopicItemFragment: TopicItemFragment } };
};

export type GetUserClassRoomHistoryQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
  includeUpcoming?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetUserClassRoomHistoryQuery = {
  getUserClassRoomHistory: Array<{
    classRoomId: string;
    startUtc: string;
    endUtc: string;
    classRoomTimezone: string;
    teacherId: string;
    teacherGivenName?: string | null;
    teacherFamilyName?: string | null;
    teacherEmail?: string | null;
    is1on1: boolean;
    userGroupId: string;
    userGroupName?: string | null;
    classRoomType: ClassRoomType;
    isProgressCheck: boolean;
    speakingLevel: SpeakingClassLevel;
    topicName?: string | null;
    capacity: number;
    participantsCount: number;
    attendedParticipantsCount: number;
    noShowParticipantsCount: number;
    feedbackCount: number;
    userNoShow: boolean;
    giftedByPromo: boolean;
    promoBonus?: {
      type: PromoBonusType;
      promoIds: Array<string>;
      planId: string;
      lessonsCountedPerWeek?: number | null;
      activeFromUtc?: string | null;
      activeToUtc?: string | null;
    } | null;
    userFeedback?: {
      id: string;
      teacherId: string;
      notes: string;
      noShow: boolean;
      participation: number;
      targetLanguage: number;
      differentSpeakingLevelSuggested?: string | null;
    } | null;
    userReview?: {
      reviewedAtUtc: string;
      reviewNotes: string;
      generalLessonScore: number;
      teacherClearanceScore: number;
      teacherInvolvementScore: number;
      teacherComfortableScore: number;
      topicUsefulnessScore: number;
      topicDifficultyScore: number;
    } | null;
    progressCheckResult?: {
      teacherId: string;
      passed: boolean;
      noShow: boolean;
      comprehension: number;
      vocabularyRange: number;
      fluency: number;
      accuracy: number;
      recommendation: Array<ProgressCheckRecommendation>;
      notes: string;
      toLevel?: string | null;
    } | null;
  }>;
};

export type ClassRoomPlanFragmentFragment = {
  id: string;
  userId: string;
  startedAtWeekUtc: string;
  endedAtWeekUtc: string;
  lessonsPerWeek: number;
  numberOfSlotIncluded: number;
  planToRecoverId?: string | null;
  unlimitedLessonsPerWeekEnabled?: boolean | null;
  unlimitedLessonsPerWeekTotalLessons?: number | null;
  warrantyConfig?: {
    enabled: boolean;
    minAttendedLessons?: number | null;
  } | null;
  bonuses?: Array<{
    type: string;
    lessonsCountedPerWeek?: number | null;
    activeFrom?: string | null;
    activeTo?: string | null;
    extraLessons?: number | null;
    extraWeeks?: number | null;
  }> | null;
  mergeHistory?: Array<{
    mergedAtUtc: string;
    premergeEndedAtWeekUtc: string;
    premergeTotalLessons: number;
    triggeringOrderId?: string | null;
    promoIds?: Array<string> | null;
    bonuses?: Array<{
      type: string;
      lessonsCountedPerWeek?: number | null;
      activeFrom?: string | null;
      activeTo?: string | null;
      extraLessons?: number | null;
      extraWeeks?: number | null;
    }> | null;
  }> | null;
} & { " $fragmentName"?: "ClassRoomPlanFragmentFragment" };

export type FrozenWeekFragment = {
  startOfWeekUtc: string;
  endOfWeekUtc: string;
} & { " $fragmentName"?: "FrozenWeekFragment" };

export type GetFreezableWeeksResponseFragment = {
  weeks: Array<{
    planId: string;
    week: { startOfWeekUtc: string; endOfWeekUtc: string };
  }>;
  remainingWeeksToFreeze: Array<{ remainingCount: number; planId: string }>;
} & { " $fragmentName"?: "GetFreezableWeeksResponseFragment" };

export type AddFrozenWeekToUserMutationVariables = Exact<{
  week: FrozenWeekInput;
  userId: Scalars["String"]["input"];
}>;

export type AddFrozenWeekToUserMutation = { addFrozenWeekToUser: boolean };

export type RemoveFrozenWeekForUserMutationVariables = Exact<{
  week: FrozenWeekInput;
  userId: Scalars["String"]["input"];
}>;

export type RemoveFrozenWeekForUserMutation = {
  removeFrozenWeekForUser: boolean;
};

export type GetFreezableWeeksByUserQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetFreezableWeeksByUserQuery = {
  getFreezableWeeksByUser: {
    " $fragmentRefs"?: {
      GetFreezableWeeksResponseFragment: GetFreezableWeeksResponseFragment;
    };
  };
};

export type GetFrozenWeeksByUserQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetFrozenWeeksByUserQuery = {
  getFrozenWeeksByUser: Array<{
    " $fragmentRefs"?: { FrozenWeekFragment: FrozenWeekFragment };
  }>;
};

export type CalculatePlanGivenSlotByParamsQueryVariables = Exact<{
  endedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  startedAtWeekUtc: Scalars["String"]["input"];
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
}>;

export type CalculatePlanGivenSlotByParamsQuery = {
  calculatePlanGivenSlotByParams: number;
};

export type CreateClassRoomPlanMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  startedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  endedAtWeekUtc: Scalars["String"]["input"];
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
  bonuses?: InputMaybe<Array<ManualPlanBonusInput> | ManualPlanBonusInput>;
}>;

export type CreateClassRoomPlanMutation = {
  createClassRoomPlan: {
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  };
};

export type DeleteClassRoomPlanMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
}>;

export type DeleteClassRoomPlanMutation = { deleteClassRoomPlan: boolean };

export type DetachLastMergedPlanMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
}>;

export type DetachLastMergedPlanMutation = {
  detachLastMergedPlan: Array<{
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  }>;
};

export type MergeUnlimitedPlansMutationVariables = Exact<{
  firstPlanId: Scalars["String"]["input"];
  secondPlanId: Scalars["String"]["input"];
}>;

export type MergeUnlimitedPlansMutation = {
  mergeUnlimitedPlans: {
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  };
};

export type GetClassRoomPlanByIdAndUserIdQueryVariables = Exact<{
  planId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}>;

export type GetClassRoomPlanByIdAndUserIdQuery = {
  getClassRoomPlanByIdAndUserId: {
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  };
};

export type UpdateUserClassRoomPlanMutationVariables = Exact<{
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  planId: Scalars["String"]["input"];
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
  startedAtWeekUtc?: InputMaybe<Scalars["String"]["input"]>;
  endedAtWeekUtc?: InputMaybe<Scalars["String"]["input"]>;
  lessonsPerWeek?: InputMaybe<Scalars["Int"]["input"]>;
  bonuses?: InputMaybe<Array<ManualPlanBonusInput> | ManualPlanBonusInput>;
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
}>;

export type UpdateUserClassRoomPlanMutation = {
  updateUserClassRoomPlan: {
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  };
};

export type GetUserClassRoomPlansQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserClassRoomPlansQuery = {
  getUserClassRoomPlans: Array<{
    " $fragmentRefs"?: {
      ClassRoomPlanFragmentFragment: ClassRoomPlanFragmentFragment;
    };
  }>;
};

export type GetUserRemainingLessonsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserRemainingLessonsQuery = { getUserRemainingLessons: number };

export type LessonFeedbackReportFragmentFragment = {
  avgParticipationScore: number;
  avgTargetLanguageScore: number;
  hasAtLeastOneFeedback: boolean;
  notes: Array<{
    classRoomStartDateUtc: string;
    classRoomTopicName: string;
    note: string;
  }>;
} & { " $fragmentName"?: "LessonFeedbackReportFragmentFragment" };

export type DeleteLessonFeedbackMutationVariables = Exact<{
  lessonFeedbackId: Scalars["String"]["input"];
}>;

export type DeleteLessonFeedbackMutation = { deleteLessonFeedback: boolean };

export type GetLessonFeedbackReportByUserQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetLessonFeedbackReportByUserQuery = {
  getLessonFeedbackReportByUser: {
    " $fragmentRefs"?: {
      LessonFeedbackReportFragmentFragment: LessonFeedbackReportFragmentFragment;
    };
  };
};

export type UserOneOnOneClassroomPlanFragment = {
  id: string;
  userId: string;
  createdAt: any;
  startDateUtc: any;
  endDateUtc: any;
  lessonsPerWeek: number;
  numberOfWeeks: number;
  oneOnOneLessonType?: OneOnOneLessonType | null;
  businessEnglishObjective?: BusinessEnglishObjective | null;
  lastLessonDateUtc?: any | null;
  speakingLevel?: SpeakingClassLevel | null;
} & { " $fragmentName"?: "UserOneOnOneClassroomPlanFragment" };

export type AddLessonsTo1on1PlanMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput> | AddLessonTo1on1PlanSlotInput;
}>;

export type AddLessonsTo1on1PlanMutation = { addLessonsTo1on1Plan: string };

export type Check1on1PlanSlotConflictsQueryVariables = Exact<{
  planId: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput> | AddLessonTo1on1PlanSlotInput;
}>;

export type Check1on1PlanSlotConflictsQuery = {
  check1on1PlanSlotConflicts: Array<{
    startDateUtc: any;
    endDateUtc: any;
    teacherConflictingClass?: {
      id: string;
      is1on1: boolean;
      startedAtUtc: string;
      endedAtUtc: string;
      participants: Array<{
        id: string;
        givenName: string;
        familyName: string;
      }>;
    } | null;
    userConflictingClass?: {
      id: string;
      is1on1: boolean;
      startedAtUtc: string;
      endedAtUtc: string;
      participants: Array<{
        id: string;
        givenName: string;
        familyName: string;
      }>;
    } | null;
  }>;
};

export type Delete1on1PlanClassRoomSilentlyMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type Delete1on1PlanClassRoomSilentlyMutation = {
  delete1on1PlanClassRoomSilently: boolean;
};

export type DeleteAll1on1PlanFutureClassRoomsSilentlyMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
}>;

export type DeleteAll1on1PlanFutureClassRoomsSilentlyMutation = {
  deleteAll1on1PlanFutureClassRoomsSilently: boolean;
};

export type Get1on1PlanManagementInfoQueryVariables = Exact<{
  planId: Scalars["String"]["input"];
}>;

export type Get1on1PlanManagementInfoQuery = {
  get1on1PlanManagementInfo: {
    teacherId?: string | null;
    bookedClassRooms: Array<{
      id: string;
      startedAtUtc: string;
      endedAtUtc: string;
      classRoomTimezone: string;
    }>;
  };
};

export type Try1on1PlanSlotTeacherSubstitutionMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  slots: Array<AddLessonTo1on1PlanSlotInput> | AddLessonTo1on1PlanSlotInput;
}>;

export type Try1on1PlanSlotTeacherSubstitutionMutation = {
  try1on1PlanSlotTeacherSubstitution: {
    successfulSubstitutions: Array<{
      classRoomId: string;
      isOnboardingLive: boolean;
      startDateUtc: any;
      endDateUtc: any;
      originalTeacher: {
        id: string;
        email: string;
        givenName: string;
        familyName: string;
        lesson1on1: boolean;
      };
      newTeacher: {
        id: string;
        email: string;
        givenName: string;
        familyName: string;
        lesson1on1: boolean;
      };
    }>;
    failedSubstitutions: Array<{
      classRoomId: string;
      startDateUtc: any;
      endDateUtc: any;
      reason: string;
      teacher?: {
        id: string;
        email: string;
        givenName: string;
        familyName: string;
        lesson1on1: boolean;
      } | null;
    }>;
  };
};

export type UpdateUser1on1ClassroomPlanLessonTypeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  oneOnOneLessonType: OneOnOneLessonType;
  businessEnglishObjective?: InputMaybe<BusinessEnglishObjective>;
}>;

export type UpdateUser1on1ClassroomPlanLessonTypeMutation = {
  updateUser1on1ClassroomPlanLessonType: {
    " $fragmentRefs"?: {
      UserOneOnOneClassroomPlanFragment: UserOneOnOneClassroomPlanFragment;
    };
  };
};

export type UpdateUser1on1ClassroomPlanSpeakingLevelMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  speakingLevel: SpeakingClassLevel;
}>;

export type UpdateUser1on1ClassroomPlanSpeakingLevelMutation = {
  updateUser1on1ClassroomPlanSpeakingLevel: {
    " $fragmentRefs"?: {
      UserOneOnOneClassroomPlanFragment: UserOneOnOneClassroomPlanFragment;
    };
  };
};

export type GetUser1on1ClassroomPlansQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUser1on1ClassroomPlansQuery = {
  getUser1on1ClassroomPlans: Array<{
    " $fragmentRefs"?: {
      UserOneOnOneClassroomPlanFragment: UserOneOnOneClassroomPlanFragment;
    };
  }>;
};

export type ProgressCheckResultFragment = {
  comprehension: number;
  accuracy: number;
  vocabularyRange: number;
  fluency: number;
  notes?: string | null;
  recommendation: Array<ProgressCheckRecommendation>;
  userId: string;
  progressCheckLevel: SpeakingClassLevel;
  progressCheckStartedAtUtc: string;
  passed: boolean;
} & { " $fragmentName"?: "ProgressCheckResultFragment" };

export type LevelChangeSuggestionFragment = {
  id: string;
  suggestedLevels: Array<SpeakingClassLevel>;
  user: { " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment } };
} & { " $fragmentName"?: "LevelChangeSuggestionFragment" };

export type ListNotResolvedLevelChangeSuggestionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListNotResolvedLevelChangeSuggestionsQuery = {
  listNotResolvedLevelChangeSuggestions: Array<{
    " $fragmentRefs"?: {
      LevelChangeSuggestionFragment: LevelChangeSuggestionFragment;
    };
  }>;
};

export type ResolveLevelSuggestionMutationVariables = Exact<{
  suggestionId: Scalars["String"]["input"];
}>;

export type ResolveLevelSuggestionMutation = {
  resolveLevelSuggestion: boolean;
};

export type GetInactiveStudentStatisticsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetInactiveStudentStatisticsQuery = {
  getInactiveStudentStatistics: {
    inactivityWindowDays: number;
    inactiveStudents: Array<{
      userId: string;
      givenName: string;
      familyName: string;
      email: string;
      speakingLevel: string;
      userGroupName?: string | null;
      hasActiveGroupPlan: boolean;
      hasActiveOneOnOnePlan: boolean;
      lastPlanEndUtc: string;
      lastAttendedLessonEndUtc?: string | null;
      nextBookedLessonStartUtc?: string | null;
    }>;
  };
};

export type GetStudentPlanStatisticsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetStudentPlanStatisticsQuery = {
  getStudentPlanStatistics: {
    activeGroupPlanStudentCount: number;
    activeOneOnOnePlanStudentCount: number;
    activePlanStudentCount: number;
    planEndingWithinDays: number;
    studentsWithGroupPlanEndingSoonCount: number;
    studentsWithOneOnOnePlanEndingSoonCount: number;
    activePlanStudentsByLevel: Array<{
      speakingLevel: string;
      studentCount: number;
    }>;
    studentsWithExhaustedLessonPack: Array<{
      userId: string;
      givenName: string;
      familyName: string;
      email: string;
      speakingLevel: string;
      userGroupName?: string | null;
      planEndUtc: string;
      lessonPackSize: number;
      usedLessons: number;
      nextBookedLessonStartUtc?: string | null;
    }>;
  };
};

export type GetUserStatisticsQueryVariables = Exact<{
  fromDay: Scalars["String"]["input"];
  toDay: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
}>;

export type GetUserStatisticsQuery = {
  getUserStatistics: {
    loggedInLast7DaysCount: number;
    loggedInLast30DaysCount: number;
    newUsersPerDay: Array<{ day: string; userCount: number }>;
  };
};

export type UserFragmentFragment = {
  id: string;
  email: string;
  speakingLevel: SpeakingLevel;
  givenName: string;
  familyName: string;
  authId: string;
  partecipatedProgressCheckCount: number;
  partecipatedSpeakingClassCount: number;
  lastSelfAssessmentLevel: SpeakingLevel;
  hideBookProgressCheckSection: boolean;
  hideBookSpeakingClassSection: boolean;
  onboardingLiveStatus?: OnboardingLiveStatus | null;
  onboardingLiveStatusUpdatedAt?: string | null;
  onboardingLiveStatusUpdatedByEmail?: string | null;
  onboardingLiveCompletedAt?: string | null;
  completedOnboardingLiveId?: string | null;
  onboardingLiveRestriction: OnboardingLiveRestriction;
  lessonFeedbacks: Array<{
    id: string;
    noShow: boolean;
    participation: number;
    targetLanguage: number;
    notes: string;
    classRoomEndDateUtc: string;
    classRoomStartDateUtc: string;
    isOneOnOne: boolean;
    teacher: {
      id: string;
      givenName: string;
      familyName: string;
      email: string;
    };
  }>;
  progressCheckResults: Array<{
    comprehension: number;
    accuracy: number;
    vocabularyRange: number;
    fluency: number;
    notes?: string | null;
    recommendation: Array<ProgressCheckRecommendation>;
    userId: string;
    progressCheckLevel: SpeakingClassLevel;
    progressCheckStartedAtUtc: string;
    passed: boolean;
    teacher: {
      givenName: string;
      familyName: string;
      email: string;
      id: string;
    };
  }>;
  userGroup: { id: string; name: string };
} & { " $fragmentName"?: "UserFragmentFragment" };

export type GetUsersEligibleForWarrantyQueryVariables = Exact<{
  plansEndBefore?: InputMaybe<Scalars["String"]["input"]>;
  plansEndAfter?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetUsersEligibleForWarrantyQuery = {
  getUsersEligibleForWarranty: Array<{
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  }>;
};

export type ListAllUsersQueryVariables = Exact<{
  nextPageToken?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  prevPageToken?: InputMaybe<Scalars["String"]["input"]>;
  withSpeakingLevel?: InputMaybe<
    Array<InputMaybe<SpeakingLevel>> | InputMaybe<SpeakingLevel>
  >;
  hasOneOnOneActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  oneOnOneLessonType?: InputMaybe<OneOnOneLessonType>;
  hasGroupPlanActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupUserGroupId?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<UserListSortField>;
  sortDirection?: InputMaybe<UserListSortDirection>;
  activityRanges?: InputMaybe<UserActivityRangesInput>;
}>;

export type ListAllUsersQuery = {
  listAllUsers: {
    hasNextPage: boolean;
    nextPageToken?: string | null;
    hasPrevPage: boolean;
    prevPageToken?: string | null;
    totalCount: number;
    users: Array<{
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  speakingLevel: SpeakingLevel;
  email: Scalars["String"]["input"];
  givenName: Scalars["String"]["input"];
  familyName: Scalars["String"]["input"];
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
  shouldSendResetPasswordEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOnboardingLiveToBeDone?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateUserMutation = {
  createUser: {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  };
};

export type EnrollUserToAllPaidContentMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type EnrollUserToAllPaidContentMutation = {
  enrollUserToAllPaidContent: boolean;
};

export type GetUserLessonsInfoQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserLessonsInfoQuery = {
  getUserLessonsInfo: {
    lessonsInfo: Array<{
      groupId: string;
      groupName: string;
      isOneOnOne: boolean;
      lessonCount: number;
      noShowCount: number;
      totalFeedbackReceived: number;
    }>;
  };
};

export type IsActiveUserForAdminByIdQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type IsActiveUserForAdminByIdQuery = {
  isActiveUserForAdminById: boolean;
};

export type SendUserResetPasswordEmailByUserIdMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type SendUserResetPasswordEmailByUserIdMutation = {
  sendUserResetPasswordEmailByUserId: boolean;
};

export type UpdateUserMutationVariables = Exact<{
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
  speakingLevel?: InputMaybe<SpeakingLevel>;
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
  onboardingLiveStatus?: InputMaybe<OnboardingLiveStatus>;
}>;

export type UpdateUserMutation = {
  updateUser: {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  };
};

export type GetUserIdsWithActivePlansQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserIdsWithActivePlansQuery = {
  getUserIdsWithActive1on1Plans: Array<string>;
  getUserIdsWithActiveGroupPlans: Array<string>;
};

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserByIdQuery = {
  getUserById: {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  };
};

export type GetAllUserGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUserGroupsQuery = {
  getAllUserGroups: Array<{
    id: string;
    name: string;
    slug: string;
    thinkificBundleId?: number | null;
    onboardingLiveRequired: boolean;
    onboardingLiveBookingWindowDays: number;
    availability?: Array<{
      weekDay: WeekDayEnum;
      timeIntervalTimezone: string;
      timeIntervals: Array<{ from: number; to: number }>;
    }> | null;
  }>;
};

export type CreateUserGroupMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  thinkificBundleId?: InputMaybe<Scalars["Int"]["input"]>;
  availability?: InputMaybe<
    Array<UserGroupAvailabilityInput> | UserGroupAvailabilityInput
  >;
  onboardingLiveRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardingLiveBookingWindowDays?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateUserGroupMutation = {
  createUserGroup: { id: string; name: string };
};

export type UpdateUserGroupMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  availability?: InputMaybe<
    Array<UserGroupAvailabilityInput> | UserGroupAvailabilityInput
  >;
  onboardingLiveRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardingLiveBookingWindowDays?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateUserGroupMutation = {
  updateUserGroup: {
    id: string;
    onboardingLiveRequired: boolean;
    onboardingLiveBookingWindowDays: number;
  };
};

export const BulkClassRoomCreationRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkClassRoomCreationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BulkClassRoomCreationRequestGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "totalClassRoomsToCreate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "authId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkClassRoomCreationRequestFragment, unknown>;
export const TeacherSubstitutionResultFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeacherSubstitutionResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TeacherSubstitutionResultGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "successfulSubstitutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isOnboardingLive" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalTeacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newTeacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "failedSubstitutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeacherSubstitutionResultFragment, unknown>;
export const User1on1ClassroomPlanToBeRedeemedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User1on1ClassroomPlanToBeRedeemed" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "User1on1ClassroomPlanToBeRedeemedGraphqlDto",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "totalNumberOfLessons" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdPlanId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  User1on1ClassroomPlanToBeRedeemedFragment,
  unknown
>;
export const BulkClassRoomCreationIntentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkClassRoomCreationIntent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BulkClassRoomCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxClassRoomNumber" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "user1on1ClassroomPlanToBeRedeemedId",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "weekSlots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dayOfWeek" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkClassRoomCreationIntentFragment, unknown>;
export const ClassRoomListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomListItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phone" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedFeedbacksCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomListItemFragment, unknown>;
export const ClassRoomWithParticipantsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomWithParticipants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoom" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomWithParticipantsFragment, unknown>;
export const ClassRoomWithoutParticipantFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomWithoutParticipant" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomWithoutParticipantDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomWithoutParticipantFragment, unknown>;
export const CompleteClassRoomFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompleteClassRoom" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompleteClassRoom" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "conferenceUri" } },
          { kind: "Field", name: { kind: "Name", value: "feedbackUrl" } },
          { kind: "Field", name: { kind: "Name", value: "feedbackReportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteClassRoomFragment, unknown>;
export const FranchiseeItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FranchiseeItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Franchisee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "phoneNumber" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          { kind: "Field", name: { kind: "Name", value: "lesson1on1" } },
          { kind: "Field", name: { kind: "Name", value: "internalTeacher" } },
          { kind: "Field", name: { kind: "Name", value: "roles" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FranchiseeItemFragment, unknown>;
export const ClassRoomTeacherFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomTeacherFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomTeacher" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "phone" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomTeacherFragmentFragment, unknown>;
export const AvailabilitySlotFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilitySlotFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AvailabilitySlotDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "slotTimezone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilitySlotFragmentFragment, unknown>;
export const OnboardingLiveSlotPlanItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnboardingLiveSlotPlanItemFragment, unknown>;
export const OnboardingLiveCreationIntentItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnboardingLiveCreationIntentItemFragment, unknown>;
export const OnboardingLiveItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLive" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endUtc" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "creationIntentId" } },
          { kind: "Field", name: { kind: "Name", value: "hasStarted" } },
          { kind: "Field", name: { kind: "Name", value: "hasEnded" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantsCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "issues" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdAtUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedAtUtc" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnboardingLiveItemFragment, unknown>;
export const OneOnOneAssignmentPdfFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OneOnOneAssignmentPdf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OneOnOneAssignmentPdf" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          { kind: "Field", name: { kind: "Name", value: "assignmentNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OneOnOneAssignmentPdfFragment, unknown>;
export const ProgressCheckPdfFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgressCheckPdf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProgressCheckPdf" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressCheckPdfFragment, unknown>;
export const TopicItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopicItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Topic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopicItemFragment, unknown>;
export const ClassRoomPlanFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomPlanFragmentFragment, unknown>;
export const FrozenWeekFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FrozenWeek" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FrozenWeekDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startOfWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endOfWeekUtc" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FrozenWeekFragment, unknown>;
export const GetFreezableWeeksResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "weeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "week" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startOfWeekUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endOfWeekUtc" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingWeeksToFreeze" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "planId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFreezableWeeksResponseFragment, unknown>;
export const LessonFeedbackReportFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LessonFeedbackReportFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserLessonFeedbackReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "avgParticipationScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avgTargetLanguageScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomTopicName" },
                },
                { kind: "Field", name: { kind: "Name", value: "note" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasAtLeastOneFeedback" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LessonFeedbackReportFragmentFragment, unknown>;
export const UserOneOnOneClassroomPlanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User1on1ClassroomPlanGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          { kind: "Field", name: { kind: "Name", value: "lastLessonDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserOneOnOneClassroomPlanFragment, unknown>;
export const ProgressCheckResultFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgressCheckResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProgressCheckResultDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "comprehension" } },
          { kind: "Field", name: { kind: "Name", value: "accuracy" } },
          { kind: "Field", name: { kind: "Name", value: "vocabularyRange" } },
          { kind: "Field", name: { kind: "Name", value: "fluency" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "recommendation" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckStartedAtUtc" },
          },
          { kind: "Field", name: { kind: "Name", value: "passed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressCheckResultFragment, unknown>;
export const UserFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const LevelChangeSuggestionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LevelChangeSuggestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LevelChangeSuggestionDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "suggestedLevels" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LevelChangeSuggestionFragment, unknown>;
export const SpeakingClassServiceAgGridQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "speakingClassServiceAgGridQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "params" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AgGridParamsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "speakingClassServiceAgGridQuery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "params" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "params" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "hasNext" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SpeakingClassServiceAgGridQueryQuery,
  SpeakingClassServiceAgGridQueryQueryVariables
>;
export const GetAvailableTeacherSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailableTeacherSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailableTeacherSlots" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slotTimezone" },
                },
                { kind: "Field", name: { kind: "Name", value: "teacherIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailableTeacherSlotsQuery,
  GetAvailableTeacherSlotsQueryVariables
>;
export const GetBookedClassRoomsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getBookedClassRooms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBookedClassRooms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomTimezone" },
                },
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "is1on1" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBookedClassRoomsQuery,
  GetBookedClassRoomsQueryVariables
>;
export const GetClassRoomSelectionDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClassRoomSelectionDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClassRoomSelectionDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "strategyName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "candidates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewAvg" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wasSelected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyCap" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tier" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxPercentOfWeeklyAvailability",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offeredSlots" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "assignedClassRooms",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxAssignableClassRooms",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasBeenReached" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClassRoomSelectionDetailQuery,
  GetClassRoomSelectionDetailQueryVariables
>;
export const GetClassRoomSelectionHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClassRoomSelectionHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClassRoomSelectionHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "strategyName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectedTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "assignedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "candidates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewAvg" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wasSelected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyCap" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tier" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxPercentOfWeeklyAvailability",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offeredSlots" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "assignedClassRooms",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxAssignableClassRooms",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasBeenReached" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClassRoomSelectionHistoryQuery,
  GetClassRoomSelectionHistoryQueryVariables
>;
export const GetClassRoomsWhereTeacherWasCandidateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClassRoomsWhereTeacherWasCandidate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getClassRoomsWhereTeacherWasCandidate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomIds" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClassRoomsWhereTeacherWasCandidateQuery,
  GetClassRoomsWhereTeacherWasCandidateQueryVariables
>;
export const CalculateBulkClassRoomCreationSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "calculateBulkClassRoomCreationSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CalculateBulkClassRoomCreationSlotsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "calculateBulkClassRoomCreationSlots",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacherConflictingClass" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speakingLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participants" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userConflictingClass" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speakingLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participants" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CalculateBulkClassRoomCreationSlotsQuery,
  CalculateBulkClassRoomCreationSlotsQueryVariables
>;
export const CreateBulk1on1ClassRoomsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createBulk1on1ClassRooms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createBulk1on1ClassRooms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                { kind: "Field", name: { kind: "Name", value: "requestId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBulk1on1ClassRoomsMutation,
  CreateBulk1on1ClassRoomsMutationVariables
>;
export const CreateBulkClassRoomCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createBulkClassRoomCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateBulkClassRoomCreationIntentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createBulkClassRoomCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfWeeks" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxClassRoomNumber" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "user1on1ClassroomPlanToBeRedeemedId",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weekSlots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dayOfWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endTime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBulkClassRoomCreationIntentMutation,
  CreateBulkClassRoomCreationIntentMutationVariables
>;
export const DeleteBulkClassRoomCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteBulkClassRoomCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteBulkClassRoomCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteBulkClassRoomCreationIntentMutation,
  DeleteBulkClassRoomCreationIntentMutationVariables
>;
export const GetActiveIntentsForStudentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getActiveIntentsForStudent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "studentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getActiveIntentsForStudent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "studentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "studentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "user1on1ClassroomPlanToBeRedeemedId",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveIntentsForStudentQuery,
  GetActiveIntentsForStudentQueryVariables
>;
export const GetAllBulkClassRoomCreationIntentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllBulkClassRoomCreationIntents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllBulkClassRoomCreationIntents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BulkClassRoomCreationIntent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkClassRoomCreationIntent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BulkClassRoomCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxClassRoomNumber" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "user1on1ClassroomPlanToBeRedeemedId",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "weekSlots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dayOfWeek" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllBulkClassRoomCreationIntentsQuery,
  GetAllBulkClassRoomCreationIntentsQueryVariables
>;
export const GetAllBulkClassRoomCreationRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllBulkClassRoomCreationRequests" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getAllBulkClassRoomCreationRequests",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BulkClassRoomCreationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkClassRoomCreationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BulkClassRoomCreationRequestGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "totalClassRoomsToCreate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "authId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllBulkClassRoomCreationRequestsQuery,
  GetAllBulkClassRoomCreationRequestsQueryVariables
>;
export const GetBulkClassRoomCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getBulkClassRoomCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBulkClassRoomCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfWeeks" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxClassRoomNumber" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "user1on1ClassroomPlanToBeRedeemedId",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "excludedSlots" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalSlots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateUtc" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weekSlots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dayOfWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endTime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBulkClassRoomCreationIntentQuery,
  GetBulkClassRoomCreationIntentQueryVariables
>;
export const GetBulkClassRoomCreationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getBulkClassRoomCreationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBulkClassRoomCreationRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BulkClassRoomCreationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkClassRoomCreationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BulkClassRoomCreationRequestGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "totalClassRoomsToCreate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "authId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBulkClassRoomCreationRequestQuery,
  GetBulkClassRoomCreationRequestQueryVariables
>;
export const GetUser1on1ClassroomPlansToBeRedeemedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUser1on1ClassroomPlansToBeRedeemed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getUser1on1ClassroomPlansToBeRedeemed",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "User1on1ClassroomPlanToBeRedeemed",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User1on1ClassroomPlanToBeRedeemed" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "User1on1ClassroomPlanToBeRedeemedGraphqlDto",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "totalNumberOfLessons" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdPlanId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUser1on1ClassroomPlansToBeRedeemedQuery,
  GetUser1on1ClassroomPlansToBeRedeemedQueryVariables
>;
export const GetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdDocument =
  {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "query",
        name: {
          kind: "Name",
          value: "getUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanId",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "limit" },
            },
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "offset" },
            },
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value:
                  "getUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanId",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "limit" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "limit" },
                  },
                },
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "offset" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "offset" },
                  },
                },
              ],
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "User1on1ClassroomPlanToBeRedeemed",
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        kind: "FragmentDefinition",
        name: { kind: "Name", value: "User1on1ClassroomPlanToBeRedeemed" },
        typeCondition: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "User1on1ClassroomPlanToBeRedeemedGraphqlDto",
          },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "user" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "familyName" },
                  },
                  { kind: "Field", name: { kind: "Name", value: "givenName" } },
                  { kind: "Field", name: { kind: "Name", value: "email" } },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "totalNumberOfLessons" },
            },
            { kind: "Field", name: { kind: "Name", value: "createdPlanId" } },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    GetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdQuery,
    GetUser1on1ClassroomPlansToBeRedeemedWithoutCreatedPlanIdQueryVariables
  >;
export const Try1on1TeacherSubstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "try1on1TeacherSubstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "try1on1TeacherSubstitution" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeacherSubstitutionResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeacherSubstitutionResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TeacherSubstitutionResultGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "successfulSubstitutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isOnboardingLive" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalTeacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newTeacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "failedSubstitutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lesson1on1" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Try1on1TeacherSubstitutionMutation,
  Try1on1TeacherSubstitutionMutationVariables
>;
export const UpdateBulkClassRoomCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateBulkClassRoomCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateBulkClassRoomCreationIntentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateBulkClassRoomCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfWeeks" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxClassRoomNumber" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "user1on1ClassroomPlanToBeRedeemedId",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "excludedSlots" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalSlots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateUtc" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weekSlots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dayOfWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endTime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBulkClassRoomCreationIntentMutation,
  UpdateBulkClassRoomCreationIntentMutationVariables
>;
export const GetMinUsedTopicInLevelAmongParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMinUsedTopicInLevelAmongParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participantIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "speakingLevel" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getMinUsedTopicsInLevelAmongParticipants",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "participantIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participantIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopicItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopicItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Topic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMinUsedTopicInLevelAmongParticipantsQuery,
  GetMinUsedTopicInLevelAmongParticipantsQueryVariables
>;
export const CreateClassRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createClassRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "capacity" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ClassRoomType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participantIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "speakingLevel" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "topicId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isOneOnOne" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createClassRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "capacity" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "capacity" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "participantIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participantIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "topicId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "topicId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isOneOnOne" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isOneOnOne" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClassRoomMutation,
  CreateClassRoomMutationVariables
>;
export const AddParticipantsToClassByEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addParticipantsToClassByEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emails" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "skipLevelCheck" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addParticipantsToClassByEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userEmails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emails" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "skipLevelCheck" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "skipLevelCheck" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomWithParticipants" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomWithParticipants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoom" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddParticipantsToClassByEmailMutation,
  AddParticipantsToClassByEmailMutationVariables
>;
export const AdminGetClassRoomByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "adminGetClassRoomById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminGetClassRoomById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CompleteClassRoom" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompleteClassRoom" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompleteClassRoom" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "conferenceUri" } },
          { kind: "Field", name: { kind: "Name", value: "feedbackUrl" } },
          { kind: "Field", name: { kind: "Name", value: "feedbackReportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminGetClassRoomByIdQuery,
  AdminGetClassRoomByIdQueryVariables
>;
export const ListClassRoomsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listClassRooms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nextToken" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "prevToken" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateRange" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListClassRoomDateInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listClassRooms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "nextToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "nextToken" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "prevToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "prevToken" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRange" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRange" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRooms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ClassRoomListItem" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                { kind: "Field", name: { kind: "Name", value: "hasPrevPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPageToken" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "prevPageToken" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomListItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phone" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedFeedbacksCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListClassRoomsQuery, ListClassRoomsQueryVariables>;
export const DeleteClassRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteClassRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClassRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteClassRoomMutation,
  DeleteClassRoomMutationVariables
>;
export const RemoveParticipantFromClassRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeParticipantFromClassRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeParticipantFromClassRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomDeleted" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ClassRoomWithParticipants",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomWithParticipants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoom" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveParticipantFromClassRoomMutation,
  RemoveParticipantFromClassRoomMutationVariables
>;
export const SwapTeacherDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "swapTeacher" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "doNotMakeOldTeacherAvailableAgain" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "swapTeacher" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherToAddId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "doNotMakeOldTeacherAvailableAgain",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "doNotMakeOldTeacherAvailableAgain",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwapTeacherMutation, SwapTeacherMutationVariables>;
export const GetTeacherCreatedAtDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherCreatedAt" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFranchiseeById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherCreatedAtQuery,
  GetTeacherCreatedAtQueryVariables
>;
export const GetTeacherAssignmentCapOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherAssignmentCapOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "upcomingWeeks" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherAssignmentCapOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "upcomingWeeks" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "upcomingWeeks" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "finalScore" } },
                { kind: "Field", name: { kind: "Name", value: "tier" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "maxPercentOfWeeklyAvailability",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weeks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weekStartUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weekEndUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offeredSlots" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedClassRooms" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "maxAssignableClassRooms",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasBeenReached" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherAssignmentCapOverviewQuery,
  GetTeacherAssignmentCapOverviewQueryVariables
>;
export const GetTeacherWeekAssignmentCapDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherWeekAssignmentCap" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "weekDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherWeekAssignmentCap" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "weekDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "weekDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weekStartUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "weekEndUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offeredSlots" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignedClassRooms" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weeklyCapWithCurrentTier" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tier" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "maxPercentOfWeeklyAvailability",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "maxAssignableClassRooms",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasBeenReached" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherWeekAssignmentCapQuery,
  GetTeacherWeekAssignmentCapQueryVariables
>;
export const RemoveAvailabilitySlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeAvailabilitySlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slotId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeAvailabilitySlot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slotId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slotId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveAvailabilitySlotMutation,
  RemoveAvailabilitySlotMutationVariables
>;
export const GetAvailabilityByTeacherForWeekDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailabilityByTeacherForWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailabilityByTeacherForWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AvailabilitySlotFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilitySlotFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AvailabilitySlotDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "slotTimezone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailabilityByTeacherForWeekQuery,
  GetAvailabilityByTeacherForWeekQueryVariables
>;
export const GetTeacherClassRoomsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherClassRooms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherClassRooms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomWithoutParticipant" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomWithoutParticipant" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomWithoutParticipantDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherClassRoomsQuery,
  GetTeacherClassRoomsQueryVariables
>;
export const LeaveTeacherCoordinatorReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "leaveTeacherCoordinatorReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fluencyScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "presenceScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clarityScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveTeacherCoordinatorReview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fluencyScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fluencyScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "presenceScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "presenceScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clarityScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clarityScore" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviewedAtUtc" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveTeacherCoordinatorReviewMutation,
  LeaveTeacherCoordinatorReviewMutationVariables
>;
export const GetNewTeacherIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getNewTeacherIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "checks" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NewTeacherCheckInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getNewTeacherIds" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "checks" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "checks" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNewTeacherIdsQuery,
  GetNewTeacherIdsQueryVariables
>;
export const GetTeacherCoordinatorReviewHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherCoordinatorReviewHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherCoordinatorReviewHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviewedAtUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scores" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fluencyScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presenceScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clarityScore" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherCoordinatorReviewHistoryQuery,
  GetTeacherCoordinatorReviewHistoryQueryVariables
>;
export const GetTeacherCoordinatorReviewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherCoordinatorReviews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherCoordinatorReviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviewedAtUtc" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherCoordinatorReviewsQuery,
  GetTeacherCoordinatorReviewsQueryVariables
>;
export const GetTeacherScoreDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherScore" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherScore" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studentBayesianAvg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coordinatorScore" },
                },
                { kind: "Field", name: { kind: "Name", value: "finalScore" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherScoreQuery,
  GetTeacherScoreQueryVariables
>;
export const GetTeacherScoresDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherScores" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherScores" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studentBayesianAvg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coordinatorScore" },
                },
                { kind: "Field", name: { kind: "Name", value: "finalScore" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherScoresQuery,
  GetTeacherScoresQueryVariables
>;
export const GetTeacherStudentReviewCountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherStudentReviewCounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherStudentReviewCounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalReviews" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherStudentReviewCountsQuery,
  GetTeacherStudentReviewCountsQueryVariables
>;
export const GetTeacherStudentReviewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeacherStudentReviews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeacherStudentReviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "simulatedStudentScore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "students" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "decayedAvg" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviews" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviewedAtUtc" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "clearanceScore" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "involvementScore" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "comfortableScore" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "teacherAvg" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "decayWeight" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeacherStudentReviewsQuery,
  GetTeacherStudentReviewsQueryVariables
>;
export const UpdateLatestTeacherCoordinatorReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateLatestTeacherCoordinatorReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fluencyScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "presenceScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clarityScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateLatestTeacherCoordinatorReview",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fluencyScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fluencyScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "presenceScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "presenceScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clarityScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clarityScore" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviewedAtUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scores" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fluencyScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presenceScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clarityScore" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLatestTeacherCoordinatorReviewMutation,
  UpdateLatestTeacherCoordinatorReviewMutationVariables
>;
export const GetTeachersWithMissingFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTeachersWithMissingFeedback" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTeachersWithMissingFeedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "classRoomsWithMissingFeedback",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classRoom" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startedAtUtc" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "speakingLevel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "is1on1" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feedbackUri" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participantsCount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "topic" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userGroup" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participantsWithoutFeedback",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeachersWithMissingFeedbackQuery,
  GetTeachersWithMissingFeedbackQueryVariables
>;
export const GetAllFranchiseesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllFranchisees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isOneOnOne" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isInternal" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllFranchisees" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "isOneOnOne" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isOneOnOne" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isInternal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isInternal" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FranchiseeItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FranchiseeItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Franchisee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "phoneNumber" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          { kind: "Field", name: { kind: "Name", value: "lesson1on1" } },
          { kind: "Field", name: { kind: "Name", value: "internalTeacher" } },
          { kind: "Field", name: { kind: "Name", value: "roles" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllFranchiseesQuery,
  GetAllFranchiseesQueryVariables
>;
export const GetAvailableTeachersInHourDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailableTeachersInHour" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailableTeachersInHour" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomTeacherFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomTeacherFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomTeacher" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "phone" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailableTeachersInHourQuery,
  GetAvailableTeachersInHourQueryVariables
>;
export const CreateFranchiseeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFranchisee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "familyName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "givenName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PhoneNumberInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lesson1on1" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internalTeacher" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TeacherRole" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tags" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TeacherTag" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFranchisee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "familyName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "familyName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "givenName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "givenName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lesson1on1" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lesson1on1" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internalTeacher" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internalTeacher" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tags" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tags" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFranchiseeMutation,
  CreateFranchiseeMutationVariables
>;
export const DeleteTeacherDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTeacher" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTeacher" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTeacherMutation,
  DeleteTeacherMutationVariables
>;
export const GetFranchiseeByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFranchiseeById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFranchiseeById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phoneNumber" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroupIds" },
                },
                { kind: "Field", name: { kind: "Name", value: "authId" } },
                { kind: "Field", name: { kind: "Name", value: "lesson1on1" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalTeacher" },
                },
                { kind: "Field", name: { kind: "Name", value: "roles" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFranchiseeByIdQuery,
  GetFranchiseeByIdQueryVariables
>;
export const UpdateTeacherDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateTeacher" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PhoneNumberInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lesson1on1" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TeacherRole" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tags" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TeacherTag" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeacher" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lesson1on1" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lesson1on1" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tags" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tags" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTeacherMutation,
  UpdateTeacherMutationVariables
>;
export const GetAllOnboardingLivePdfsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllOnboardingLivePdfs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllOnboardingLivePdfs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllOnboardingLivePdfsQuery,
  GetAllOnboardingLivePdfsQueryVariables
>;
export const UpsertOnboardingLivePdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "upsertOnboardingLivePdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertOnboardingLivePdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertOnboardingLivePdfMutation,
  UpsertOnboardingLivePdfMutationVariables
>;
export const DeleteOnboardingLivePdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteOnboardingLivePdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOnboardingLivePdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOnboardingLivePdfMutation,
  DeleteOnboardingLivePdfMutationVariables
>;
export const GetOnboardingLiveStatisticsRecordsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLiveStatisticsRecords" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLiveStatisticsRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toUtc" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lives" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantsCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEnded" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feedback" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participantsCount",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletedLives" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantsCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancellations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onboardingLiveId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelledBy" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "conductorChanges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onboardingLiveId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fromTeacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLiveStatisticsRecordsQuery,
  GetOnboardingLiveStatisticsRecordsQueryVariables
>;
export const GetOnboardingLiveFunnelStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLiveFunnelStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLiveFunnelStatistics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toUtc" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "usersWithOnboardingLiveToBeDone",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usersWaitingForMoreThanAWeek" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "usersWhoCompletedOnboardingLive",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "averageDaysToCompleteOnboardingLive",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "medianDaysToCompleteOnboardingLive",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLiveFunnelStatisticsQuery,
  GetOnboardingLiveFunnelStatisticsQueryVariables
>;
export const CreateOnboardingLiveCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOnboardingLiveCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOnboardingLiveCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOnboardingLiveCreationIntentMutation,
  CreateOnboardingLiveCreationIntentMutationVariables
>;
export const GetOnboardingLiveByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLiveById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLiveById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OnboardingLiveItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLive" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endUtc" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "creationIntentId" } },
          { kind: "Field", name: { kind: "Name", value: "hasStarted" } },
          { kind: "Field", name: { kind: "Name", value: "hasEnded" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantsCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "issues" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdAtUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedAtUtc" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLiveByIdQuery,
  GetOnboardingLiveByIdQueryVariables
>;
export const CheckOnboardingLiveConductorChangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "checkOnboardingLiveConductorChange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkOnboardingLiveConductorChange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckOnboardingLiveConductorChangeMutation,
  CheckOnboardingLiveConductorChangeMutationVariables
>;
export const ChangeOnboardingLiveConductorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "changeOnboardingLiveConductor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "makeReplacedConductorAvailableAgain",
            },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeOnboardingLiveConductor" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "makeReplacedConductorAvailableAgain",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "makeReplacedConductorAvailableAgain",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLive" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeOnboardingLiveConductorMutation,
  ChangeOnboardingLiveConductorMutationVariables
>;
export const DeleteOnboardingLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteOnboardingLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "makeConductorAvailableAgain" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOnboardingLive" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "makeConductorAvailableAgain" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "makeConductorAvailableAgain" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOnboardingLiveMutation,
  DeleteOnboardingLiveMutationVariables
>;
export const AddParticipantsToOnboardingLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addParticipantsToOnboardingLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userEmails" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addParticipantsToOnboardingLive" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userEmails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userEmails" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddParticipantsToOnboardingLiveMutation,
  AddParticipantsToOnboardingLiveMutationVariables
>;
export const RemoveParticipantFromOnboardingLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeParticipantFromOnboardingLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "removeParticipantFromOnboardingLive",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveParticipantFromOnboardingLiveMutation,
  RemoveParticipantFromOnboardingLiveMutationVariables
>;
export const GetOnboardingLiveCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLiveCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLiveCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLiveCreationIntentQuery,
  GetOnboardingLiveCreationIntentQueryVariables
>;
export const ChangeOnboardingLiveCreationIntentUserGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "changeOnboardingLiveCreationIntentUserGroup",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "changeOnboardingLiveCreationIntentUserGroup",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeOnboardingLiveCreationIntentUserGroupMutation,
  ChangeOnboardingLiveCreationIntentUserGroupMutationVariables
>;
export const AddOnboardingLiveCreationIntentSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addOnboardingLiveCreationIntentSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slots" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "OnboardingLiveSlotInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "addOnboardingLiveCreationIntentSlots",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slots" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slots" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddOnboardingLiveCreationIntentSlotsMutation,
  AddOnboardingLiveCreationIntentSlotsMutationVariables
>;
export const UpdateOnboardingLiveCreationIntentSlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateOnboardingLiveCreationIntentSlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slotId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slot" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OnboardingLiveSlotInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateOnboardingLiveCreationIntentSlot",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slotId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slotId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slot" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slot" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOnboardingLiveCreationIntentSlotMutation,
  UpdateOnboardingLiveCreationIntentSlotMutationVariables
>;
export const RemoveOnboardingLiveCreationIntentSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeOnboardingLiveCreationIntentSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slotIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "removeOnboardingLiveCreationIntentSlots",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slotIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slotIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveOnboardingLiveCreationIntentSlotsMutation,
  RemoveOnboardingLiveCreationIntentSlotsMutationVariables
>;
export const CheckOnboardingLiveCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "checkOnboardingLiveCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkOnboardingLiveCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckOnboardingLiveCreationIntentMutation,
  CheckOnboardingLiveCreationIntentMutationVariables
>;
export const ConfirmOnboardingLiveCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmOnboardingLiveCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "confirmOnboardingLiveCreationIntent",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmOnboardingLiveCreationIntentMutation,
  ConfirmOnboardingLiveCreationIntentMutationVariables
>;
export const CancelOnboardingLiveCreationIntentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cancelOnboardingLiveCreationIntent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOnboardingLiveCreationIntent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "intentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelOnboardingLiveCreationIntentMutation,
  CancelOnboardingLiveCreationIntentMutationVariables
>;
export const GetOnboardingLiveCreationIntentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLiveCreationIntents" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLiveCreationIntents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OnboardingLiveCreationIntentItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveSlotPlanItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveSlotPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "forcedRoster" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reassignment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromTeacherId" },
                },
                { kind: "Field", name: { kind: "Name", value: "toTeacherId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "issues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedClassRoom" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveCreationIntentItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLiveCreationIntent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "createdAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledByEmail" } },
          { kind: "Field", name: { kind: "Name", value: "cancelledAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "completedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lastCheckedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedTeacherId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationFailureReason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastCheckPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnboardingLiveSlotPlanItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLiveCreationIntentsQuery,
  GetOnboardingLiveCreationIntentsQueryVariables
>;
export const GetOnboardingLivesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOnboardingLives" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "period" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OnboardingLiveListPeriod" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingLives" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "period" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "period" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OnboardingLiveItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnboardingLiveItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnboardingLive" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endUtc" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "teacherId" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "creationIntentId" } },
          { kind: "Field", name: { kind: "Name", value: "hasStarted" } },
          { kind: "Field", name: { kind: "Name", value: "hasEnded" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantsCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "issues" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdAtUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedAtUtc" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnboardingLivesQuery,
  GetOnboardingLivesQueryVariables
>;
export const GetAllOneOnOneAssignmentPdfsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllOneOnOneAssignmentPdfs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllOneOnOneAssignmentPdfs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OneOnOneAssignmentPdf" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OneOnOneAssignmentPdf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OneOnOneAssignmentPdf" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          { kind: "Field", name: { kind: "Name", value: "assignmentNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllOneOnOneAssignmentPdfsQuery,
  GetAllOneOnOneAssignmentPdfsQueryVariables
>;
export const CreateOneOnOneAssignmentPdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOneOnOneAssignmentPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assignmentNumber" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OneOnOneLessonType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BusinessEnglishObjective" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOneOnOneAssignmentPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assignmentNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assignmentNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oneOnOneLessonType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessEnglishObjective" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "businessEnglishObjective" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignmentNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessEnglishObjective" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOneOnOneAssignmentPdfMutation,
  CreateOneOnOneAssignmentPdfMutationVariables
>;
export const DeleteOneOnOneAssignmentPdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteOneOnOneAssignmentPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assignmentNumber" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OneOnOneLessonType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BusinessEnglishObjective" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOneOnOneAssignmentPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assignmentNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assignmentNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oneOnOneLessonType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessEnglishObjective" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "businessEnglishObjective" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOneOnOneAssignmentPdfMutation,
  DeleteOneOnOneAssignmentPdfMutationVariables
>;
export const UpsertOneOnOneAssignmentPdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "upsertOneOnOneAssignmentPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assignmentNumber" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OneOnOneLessonType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BusinessEnglishObjective" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertOneOnOneAssignmentPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assignmentNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assignmentNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oneOnOneLessonType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessEnglishObjective" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "businessEnglishObjective" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertOneOnOneAssignmentPdfMutation,
  UpsertOneOnOneAssignmentPdfMutationVariables
>;
export const GetOneOnOnePlanPurchasesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOneOnOnePlanPurchases" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingFormCompleted" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOneOnOnePlanPurchases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingFormCompleted" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingFormCompleted" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "orderId" } },
                { kind: "Field", name: { kind: "Name", value: "purchasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "userEmail" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingFormCompleted" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasActiveGroupPlan" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastGroupPlanEndDate" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOneOnOnePlanPurchasesQuery,
  GetOneOnOnePlanPurchasesQueryVariables
>;
export const GetAllProgressCheckPdfsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllProgressCheckPdfs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllProgressCheckPdfs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProgressCheckPdf" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgressCheckPdf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProgressCheckPdf" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllProgressCheckPdfsQuery,
  GetAllProgressCheckPdfsQueryVariables
>;
export const CreateProgressCheckPdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createProgressCheckPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProgressCheckPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateProgressCheckPdfMutation,
  CreateProgressCheckPdfMutationVariables
>;
export const UpsertProgressCheckPdfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "upsertProgressCheckPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertProgressCheckPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertProgressCheckPdfMutation,
  UpsertProgressCheckPdfMutationVariables
>;
export const GetAllTopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllTopics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllTopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopicItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopicItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Topic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllTopicsQuery, GetAllTopicsQueryVariables>;
export const CreateTopicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createTopic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nameIt" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "level" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTopic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "nameIt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "nameIt" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "level" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroupIds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTopicMutation, CreateTopicMutationVariables>;
export const EditTopicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "editTopic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nameIt" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pdfUrl" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "editTopic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "nameIt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "nameIt" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pdfUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pdfUrl" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopicItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopicItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Topic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditTopicMutation, EditTopicMutationVariables>;
export const LogicallyDeleteTopicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "logicallyDeleteTopic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "topicId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "logicallyDeleteTopic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "topicId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LogicallyDeleteTopicMutation,
  LogicallyDeleteTopicMutationVariables
>;
export const GetTopicByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTopicById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTopicById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopicItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopicItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Topic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
          { kind: "Field", name: { kind: "Name", value: "userGroupIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTopicByIdQuery, GetTopicByIdQueryVariables>;
export const GetUserClassRoomHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserClassRoomHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeUpcoming" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserClassRoomHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeUpcoming" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "includeUpcoming" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classRoomId" } },
                { kind: "Field", name: { kind: "Name", value: "startUtc" } },
                { kind: "Field", name: { kind: "Name", value: "endUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomTimezone" },
                },
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacherGivenName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacherFamilyName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacherEmail" },
                },
                { kind: "Field", name: { kind: "Name", value: "is1on1" } },
                { kind: "Field", name: { kind: "Name", value: "userGroupId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userGroupName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isProgressCheck" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speakingLevel" },
                },
                { kind: "Field", name: { kind: "Name", value: "topicName" } },
                { kind: "Field", name: { kind: "Name", value: "capacity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendedParticipantsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noShowParticipantsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feedbackCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "userNoShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "giftedByPromo" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "promoBonus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "promoIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "planId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFromUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeToUtc" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userFeedback" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noShow" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetLanguage" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "differentSpeakingLevelSuggested",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userReview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewNotes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generalLessonScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherClearanceScore" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "teacherInvolvementScore",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "teacherComfortableScore",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topicUsefulnessScore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topicDifficultyScore" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacherId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "passed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noShow" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comprehension" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vocabularyRange" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fluency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accuracy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recommendation" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "toLevel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserClassRoomHistoryQuery,
  GetUserClassRoomHistoryQueryVariables
>;
export const AddFrozenWeekToUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addFrozenWeekToUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "week" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FrozenWeekInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addFrozenWeekToUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "week" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "week" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddFrozenWeekToUserMutation,
  AddFrozenWeekToUserMutationVariables
>;
export const RemoveFrozenWeekForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeFrozenWeekForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "week" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FrozenWeekInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFrozenWeekForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "week" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "week" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveFrozenWeekForUserMutation,
  RemoveFrozenWeekForUserMutationVariables
>;
export const GetFreezableWeeksByUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFreezableWeeksByUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFreezableWeeksByUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "GetFreezableWeeksResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "weeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "week" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startOfWeekUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endOfWeekUtc" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingWeeksToFreeze" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "planId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFreezableWeeksByUserQuery,
  GetFreezableWeeksByUserQueryVariables
>;
export const GetFrozenWeeksByUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFrozenWeeksByUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFrozenWeeksByUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FrozenWeek" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FrozenWeek" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FrozenWeekDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startOfWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endOfWeekUtc" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFrozenWeeksByUserQuery,
  GetFrozenWeeksByUserQueryVariables
>;
export const CalculatePlanGivenSlotByParamsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "calculatePlanGivenSlotByParams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endedAtWeekUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lessonsPerWeek" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startedAtWeekUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "unlimitedLessonPerWeek" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UnlimitedLessonPerWeekEnabledInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "calculatePlanGivenSlotByParams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "endedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lessonsPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lessonsPerWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CalculatePlanGivenSlotByParamsQuery,
  CalculatePlanGivenSlotByParamsQueryVariables
>;
export const CreateClassRoomPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createClassRoomPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startedAtWeekUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lessonsPerWeek" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endedAtWeekUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planToRecoverId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "warrantyConfig" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "UserClassRoomPlanWarrantyConfigInputDto",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "unlimitedLessonPerWeek" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UnlimitedLessonPerWeekEnabledInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bonuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ManualPlanBonusInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createClassRoomPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "endedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lessonsPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lessonsPerWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "planToRecoverId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planToRecoverId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "warrantyConfig" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "warrantyConfig" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bonuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bonuses" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClassRoomPlanMutation,
  CreateClassRoomPlanMutationVariables
>;
export const DeleteClassRoomPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteClassRoomPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClassRoomPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteClassRoomPlanMutation,
  DeleteClassRoomPlanMutationVariables
>;
export const DetachLastMergedPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "detachLastMergedPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "detachLastMergedPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DetachLastMergedPlanMutation,
  DetachLastMergedPlanMutationVariables
>;
export const MergeUnlimitedPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mergeUnlimitedPlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstPlanId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "secondPlanId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeUnlimitedPlans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstPlanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstPlanId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "secondPlanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "secondPlanId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MergeUnlimitedPlansMutation,
  MergeUnlimitedPlansMutationVariables
>;
export const GetClassRoomPlanByIdAndUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClassRoomPlanByIdAndUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClassRoomPlanByIdAndUserId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClassRoomPlanByIdAndUserIdQuery,
  GetClassRoomPlanByIdAndUserIdQueryVariables
>;
export const UpdateUserClassRoomPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserClassRoomPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planToRecoverId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "warrantyConfig" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "UserClassRoomPlanWarrantyConfigInputDto",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startedAtWeekUtc" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endedAtWeekUtc" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lessonsPerWeek" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bonuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ManualPlanBonusInput" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "unlimitedLessonPerWeek" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UnlimitedLessonPerWeekEnabledInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserClassRoomPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planToRecoverId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planToRecoverId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "warrantyConfig" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "warrantyConfig" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endedAtWeekUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endedAtWeekUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lessonsPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lessonsPerWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bonuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bonuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "unlimitedLessonPerWeek" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserClassRoomPlanMutation,
  UpdateUserClassRoomPlanMutationVariables
>;
export const GetUserClassRoomPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserClassRoomPlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserClassRoomPlans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomPlanFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomPlanFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserClassRoomPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numberOfSlotIncluded" },
          },
          { kind: "Field", name: { kind: "Name", value: "planToRecoverId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warrantyConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minAttendedLessons" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unlimitedLessonsPerWeekEnabled" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unlimitedLessonsPerWeekTotalLessons",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "bonuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsCountedPerWeek" },
                },
                { kind: "Field", name: { kind: "Name", value: "activeFrom" } },
                { kind: "Field", name: { kind: "Name", value: "activeTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extraLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "extraWeeks" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mergedAtUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeEndedAtWeekUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "premergeTotalLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringOrderId" },
                },
                { kind: "Field", name: { kind: "Name", value: "promoIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bonuses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonsCountedPerWeek" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraLessons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extraWeeks" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserClassRoomPlansQuery,
  GetUserClassRoomPlansQueryVariables
>;
export const GetUserRemainingLessonsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserRemainingLessons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRemainingLessons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserRemainingLessonsQuery,
  GetUserRemainingLessonsQueryVariables
>;
export const DeleteLessonFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteLessonFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lessonFeedbackId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLessonFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "lessonFeedbackId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lessonFeedbackId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteLessonFeedbackMutation,
  DeleteLessonFeedbackMutationVariables
>;
export const GetLessonFeedbackReportByUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getLessonFeedbackReportByUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLessonFeedbackReportByUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LessonFeedbackReportFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LessonFeedbackReportFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserLessonFeedbackReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "avgParticipationScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avgTargetLanguageScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomTopicName" },
                },
                { kind: "Field", name: { kind: "Name", value: "note" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasAtLeastOneFeedback" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLessonFeedbackReportByUserQuery,
  GetLessonFeedbackReportByUserQueryVariables
>;
export const AddLessonsTo1on1PlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addLessonsTo1on1Plan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slots" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "AddLessonTo1on1PlanSlotInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLessonsTo1on1Plan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slots" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slots" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddLessonsTo1on1PlanMutation,
  AddLessonsTo1on1PlanMutationVariables
>;
export const Check1on1PlanSlotConflictsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "check1on1PlanSlotConflicts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slots" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "AddLessonTo1on1PlanSlotInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "check1on1PlanSlotConflicts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slots" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slots" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startDateUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacherConflictingClass" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participants" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userConflictingClass" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is1on1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participants" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Check1on1PlanSlotConflictsQuery,
  Check1on1PlanSlotConflictsQueryVariables
>;
export const Delete1on1PlanClassRoomSilentlyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "delete1on1PlanClassRoomSilently" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "delete1on1PlanClassRoomSilently" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Delete1on1PlanClassRoomSilentlyMutation,
  Delete1on1PlanClassRoomSilentlyMutationVariables
>;
export const DeleteAll1on1PlanFutureClassRoomsSilentlyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "deleteAll1on1PlanFutureClassRoomsSilently",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleteAll1on1PlanFutureClassRoomsSilently",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAll1on1PlanFutureClassRoomsSilentlyMutation,
  DeleteAll1on1PlanFutureClassRoomsSilentlyMutationVariables
>;
export const Get1on1PlanManagementInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "get1on1PlanManagementInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "get1on1PlanManagementInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "teacherId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bookedClassRooms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAtUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classRoomTimezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Get1on1PlanManagementInfoQuery,
  Get1on1PlanManagementInfoQueryVariables
>;
export const Try1on1PlanSlotTeacherSubstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "try1on1PlanSlotTeacherSubstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slots" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "AddLessonTo1on1PlanSlotInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "try1on1PlanSlotTeacherSubstitution" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slots" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slots" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successfulSubstitutions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classRoomId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOnboardingLive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originalTeacher" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lesson1on1" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newTeacher" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lesson1on1" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failedSubstitutions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classRoomId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "teacher" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "givenName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "familyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lesson1on1" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Try1on1PlanSlotTeacherSubstitutionMutation,
  Try1on1PlanSlotTeacherSubstitutionMutationVariables
>;
export const UpdateUser1on1ClassroomPlanLessonTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser1on1ClassroomPlanLessonType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OneOnOneLessonType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BusinessEnglishObjective" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateUser1on1ClassroomPlanLessonType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oneOnOneLessonType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessEnglishObjective" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "businessEnglishObjective" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User1on1ClassroomPlanGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          { kind: "Field", name: { kind: "Name", value: "lastLessonDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUser1on1ClassroomPlanLessonTypeMutation,
  UpdateUser1on1ClassroomPlanLessonTypeMutationVariables
>;
export const UpdateUser1on1ClassroomPlanSpeakingLevelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser1on1ClassroomPlanSpeakingLevel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "speakingLevel" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingClassLevel" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateUser1on1ClassroomPlanSpeakingLevel",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User1on1ClassroomPlanGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          { kind: "Field", name: { kind: "Name", value: "lastLessonDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUser1on1ClassroomPlanSpeakingLevelMutation,
  UpdateUser1on1ClassroomPlanSpeakingLevelMutationVariables
>;
export const GetUser1on1ClassroomPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUser1on1ClassroomPlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUser1on1ClassroomPlans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOneOnOneClassroomPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User1on1ClassroomPlanGraphqlDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "lessonsPerWeek" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfWeeks" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessEnglishObjective" },
          },
          { kind: "Field", name: { kind: "Name", value: "lastLessonDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUser1on1ClassroomPlansQuery,
  GetUser1on1ClassroomPlansQueryVariables
>;
export const ListNotResolvedLevelChangeSuggestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listNotResolvedLevelChangeSuggestions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "listNotResolvedLevelChangeSuggestions",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LevelChangeSuggestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LevelChangeSuggestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LevelChangeSuggestionDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "suggestedLevels" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListNotResolvedLevelChangeSuggestionsQuery,
  ListNotResolvedLevelChangeSuggestionsQueryVariables
>;
export const ResolveLevelSuggestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resolveLevelSuggestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "suggestionId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resolveLevelSuggestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "suggestionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "suggestionId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResolveLevelSuggestionMutation,
  ResolveLevelSuggestionMutationVariables
>;
export const GetInactiveStudentStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInactiveStudentStatistics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInactiveStudentStatistics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inactivityWindowDays" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inactiveStudents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speakingLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasActiveGroupPlan" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasActiveOneOnOnePlan" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastPlanEndUtc" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastAttendedLessonEndUtc",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "nextBookedLessonStartUtc",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInactiveStudentStatisticsQuery,
  GetInactiveStudentStatisticsQueryVariables
>;
export const GetStudentPlanStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getStudentPlanStatistics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getStudentPlanStatistics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeGroupPlanStudentCount" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "activeOneOnOnePlanStudentCount",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activePlanStudentCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "planEndingWithinDays" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "studentsWithGroupPlanEndingSoonCount",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "studentsWithOneOnOnePlanEndingSoonCount",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activePlanStudentsByLevel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speakingLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "studentCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "studentsWithExhaustedLessonPack",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speakingLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userGroupName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "planEndUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonPackSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedLessons" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "nextBookedLessonStartUtc",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStudentPlanStatisticsQuery,
  GetStudentPlanStatisticsQueryVariables
>;
export const GetUserStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDay" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDay" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserStatistics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDay" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDay" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newUsersPerDay" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "day" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loggedInLast7DaysCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loggedInLast30DaysCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserStatisticsQuery,
  GetUserStatisticsQueryVariables
>;
export const GetUsersEligibleForWarrantyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUsersEligibleForWarranty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plansEndBefore" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plansEndAfter" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUsersEligibleForWarranty" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plansEndBefore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plansEndBefore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plansEndAfter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plansEndAfter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUsersEligibleForWarrantyQuery,
  GetUsersEligibleForWarrantyQueryVariables
>;
export const ListAllUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listAllUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nextPageToken" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "prevPageToken" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withSpeakingLevel" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hasOneOnOneActive" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oneOnOneLessonType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OneOnOneLessonType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hasGroupPlanActive" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "groupUserGroupId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserListSortField" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortDirection" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserListSortDirection" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "activityRanges" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserActivityRangesInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listAllUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "nextPageToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "nextPageToken" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "search" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "prevPageToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "prevPageToken" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "withSpeakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "withSpeakingLevel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hasOneOnOneActive" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hasOneOnOneActive" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oneOnOneLessonType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oneOnOneLessonType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hasGroupPlanActive" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hasGroupPlanActive" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "groupUserGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "groupUserGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortDirection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "activityRanges" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "activityRanges" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPageToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "hasPrevPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "prevPageToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListAllUsersQuery, ListAllUsersQueryVariables>;
export const CreateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "speakingLevel" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpeakingLevel" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "givenName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "familyName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "activateAccount" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shouldSendResetPasswordEmail" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isOnboardingLiveToBeDone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "speakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "givenName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "givenName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "familyName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "familyName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "activateAccount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "activateAccount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hideBookSpeakingClassSection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hideBookSpeakingClassSection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hideBookProgressCheckSection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hideBookProgressCheckSection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "shouldSendResetPasswordEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shouldSendResetPasswordEmail" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isOnboardingLiveToBeDone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isOnboardingLiveToBeDone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const EnrollUserToAllPaidContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "enrollUserToAllPaidContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrollUserToAllPaidContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnrollUserToAllPaidContentMutation,
  EnrollUserToAllPaidContentMutationVariables
>;
export const GetUserLessonsInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserLessonsInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserLessonsInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lessonsInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOneOnOne" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lessonCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noShowCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalFeedbackReceived" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserLessonsInfoQuery,
  GetUserLessonsInfoQueryVariables
>;
export const IsActiveUserForAdminByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "isActiveUserForAdminById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isActiveUserForAdminById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsActiveUserForAdminByIdQuery,
  IsActiveUserForAdminByIdQueryVariables
>;
export const SendUserResetPasswordEmailByUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendUserResetPasswordEmailByUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendUserResetPasswordEmailByUserId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendUserResetPasswordEmailByUserIdMutation,
  SendUserResetPasswordEmailByUserIdMutationVariables
>;
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "familyName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "givenName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "speakingLevel" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SpeakingLevel" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "activateAccount" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userGroupId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OnboardingLiveStatus" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "familyName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "familyName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "givenName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "givenName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speakingLevel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "speakingLevel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "activateAccount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "activateAccount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hideBookSpeakingClassSection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hideBookSpeakingClassSection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hideBookProgressCheckSection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hideBookProgressCheckSection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveStatus" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveStatus" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetUserIdsWithActivePlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserIdsWithActivePlans" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserIdsWithActive1on1Plans" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserIdsWithActiveGroupPlans" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserIdsWithActivePlansQuery,
  GetUserIdsWithActivePlansQueryVariables
>;
export const GetUserByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "authId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedProgressCheckCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "partecipatedSpeakingClassCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastSelfAssessmentLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lessonFeedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "noShow" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomEndDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRoomStartDateUtc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isOneOnOne" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progressCheckResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teacher" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comprehension" },
                },
                { kind: "Field", name: { kind: "Name", value: "accuracy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vocabularyRange" },
                },
                { kind: "Field", name: { kind: "Name", value: "fluency" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendation" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressCheckStartedAtUtc" },
                },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveStatusUpdatedByEmail" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveCompletedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "completedOnboardingLiveId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "onboardingLiveRestriction" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetAllUserGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllUserGroups" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllUserGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thinkificBundleId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveRequired" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "onboardingLiveBookingWindowDays",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availability" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weekDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timeIntervalTimezone" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timeIntervals" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "from" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "to" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllUserGroupsQuery,
  GetAllUserGroupsQueryVariables
>;
export const CreateUserGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createUserGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "thinkificBundleId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "availability" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "UserGroupAvailabilityInput" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveRequired" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveBookingWindowDays" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "thinkificBundleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "thinkificBundleId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "availability" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "availability" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveRequired" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveRequired" },
                },
              },
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "onboardingLiveBookingWindowDays",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "onboardingLiveBookingWindowDays",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateUserGroupMutation,
  CreateUserGroupMutationVariables
>;
export const UpdateUserGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "availability" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "UserGroupAvailabilityInput" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveRequired" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingLiveBookingWindowDays" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "availability" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "availability" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "onboardingLiveRequired" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onboardingLiveRequired" },
                },
              },
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "onboardingLiveBookingWindowDays",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "onboardingLiveBookingWindowDays",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingLiveRequired" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "onboardingLiveBookingWindowDays",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserGroupMutation,
  UpdateUserGroupMutationVariables
>;
